import { images as values } from "./imageValues";

export const Board = [
  {
    boardName: "Music",
    boardNameHi: "संगीत",
    boardImage: values.BOARD1,
    typeOfMarket: [
      {
        bazaarName: "HAUZ KHAS MARKET",
        bazaarNameHindi: "हौज़ खास मार्केट",
        imageName: values.MARKETONENEW,
        pos1: 21,
        pos2: 22,
        pos3: 23,
        pos4: 10,
        pos5: 11,
        pos6: 12,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 1,
            id: 1,
            questionImage: values.BOARD1_QUESTION1ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD1_QUESTION1FULL,
            images: [
              {
                name: values.BOARD1_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD1_QUESTION2BLANK,
                id: "2",
              },
              {
                name: values.BOARD1_QUESTION3BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 2,
            questionImage: values.BOARD1_QUESTION2ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD1_QUESTION2FULL,
            images: [
              {
                name: values.BOARD1_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD1_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD1_QUESTION2BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 3,
            questionImage: values.BOARD1_QUESTION3ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD1_QUESTION3FULL,
            images: [
              {
                name: values.BOARD1_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD1_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD1_QUESTION5BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 1,
            questionImage: values.BOARD1_QUESTION4ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD1_QUESTION4FULL,
            images: [
              {
                name: values.BOARD1_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD1_QUESTION4BLANK,
                id: "2",
              },
              {
                name: values.BOARD1_QUESTION8BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 2,
            questionImage: values.BOARD1_QUESTION5ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD1_QUESTION5FULL,
            images: [
              {
                name: values.BOARD1_QUESTION5BLANK,
                id: "1",
              },
              {
                name: values.BOARD1_QUESTION6BLANK,
                id: "2",
              },
              {
                name: values.BOARD1_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 3,
            questionImage: values.BOARD1_QUESTION6ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD1_QUESTION6FULL,
            images: [
              {
                name: values.BOARD1_QUESTION10BLANK,
                id: "1",
              },
              {
                name: values.BOARD1_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD1_QUESTION6BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "CHOR BAZAAR",
        bazaarNameHindi: "चोर बाज़ार",
        imageName: values.MARKETTWONEW,
        pos1: 33,
        pos2: 34,
        pos3: 35,
        pos4: 30,
        pos5: 31,
        pos6: 32,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 3,
            id: 1,
            questionImage: values.BOARD1_QUESTION7ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD1_QUESTION7FULL,
            images: [
              {
                name: values.BOARD1_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD1_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD1_QUESTION14BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 2,
            questionImage: values.BOARD1_QUESTION8ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD1_QUESTION8FULL,
            images: [
              {
                name: values.BOARD1_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD1_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD1_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 3,
            questionImage: values.BOARD1_QUESTION9ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD1_QUESTION9FULL,
            images: [
              {
                name: values.BOARD1_QUESTION9BLANK,
                id: "1",
              },
              {
                name: values.BOARD1_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD1_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 1,
            questionImage: values.BOARD1_QUESTION10ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD1_QUESTION10FULL,
            images: [
              {
                name: values.BOARD1_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD1_QUESTION13BLANK,
                id: "2",
              },
              {
                name: values.BOARD1_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 2,
            questionImage: values.BOARD1_QUESTION11ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD1_QUESTION11FULL,
            images: [
              {
                name: values.BOARD1_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD1_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD1_QUESTION12BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 3,
            questionImage: values.BOARD1_QUESTION12ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD1_QUESTION12FULL,
            images: [
              {
                name: values.BOARD1_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD1_QUESTION12BLANK,
                id: "2",
              },
              {
                name: values.BOARD1_QUESTION13BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "NEHRU MARKET",
        bazaarNameHindi: "नेहरू मार्केट",
        imageName: values.MARKETTHREENEW,
        pos1: 54,
        pos2: 55,
        pos3: 43,
        pos4: 42,
        pos5: 38,
        pos6: 39,
        height: 140,
        width: 93,
        question: [
          {
            questionRound: 5,
            id: 1,
            questionImage: values.BOARD1_QUESTION13ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD1_QUESTION13FULL,
            images: [
              {
                name: values.BOARD1_QUESTION13BLANK,
                id: "1",
              },
              {
                name: values.BOARD1_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD1_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 2,
            questionImage: values.BOARD1_QUESTION14ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD1_QUESTION14FULL,
            images: [
              {
                name: values.BOARD1_QUESTION15BLANK,
                id: "1",
              },
              {
                name: values.BOARD1_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD1_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 3,
            questionImage: values.BOARD1_QUESTION15ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD1_QUESTION15FULL,
            images: [
              {
                name: values.BOARD1_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD1_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD1_QUESTION15BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 1,
            questionImage: values.BOARD1_QUESTION16ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD1_QUESTION16FULL,
            images: [
              {
                name: values.BOARD1_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD1_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD1_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 2,
            questionImage: values.BOARD1_QUESTION17ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD1_QUESTION17FULL,
            images: [
              {
                name: values.BOARD1_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD1_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD1_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 3,
            questionImage: values.BOARD1_QUESTION18ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD1_QUESTION18FULL,
            images: [
              {
                name: values.BOARD1_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD1_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD1_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
    ],
    typeOfVehicle: [
      // {
      //   door: [{ position: 64, image: values.MATCHBOX_DOOR_2 }],
      // },
      {
        train: [{ position: 45, image: values.TRAIN }],
      },
      { car: [{ position: 4, image: values.OLDCAR }] },
      {
        truck: [{ position: 28, image: values.PGNRBUS }],
      },
      { bus: [{ position: 14, image: values.REDBUS }] },
      { aeroplane: [{ position: 51, image: values.AEROPLANE }] },
      { bus2: [{ position: 59, image: values.REDBUS }] },
    ],
    gameCompleteImages: [
      { front: values.FRONTONE, back: values.BACKONE },
      { front: values.FRONTWO, back: values.BACKTWO },
      { front: values.FRONTTHREE, back: values.BACKTHREE },
      { front: values.FRONTFOUR, back: values.BACKFOUR },
    ],

    collectionRoomImages: [
      values.BOARD1_QUESTION1FULL,
      values.BOARD1_QUESTION2FULL,
      values.BOARD1_QUESTION3FULL,
      values.BOARD1_QUESTION4FULL,
      values.BOARD1_QUESTION5FULL,
      values.BOARD1_QUESTION6FULL,
      values.BOARD1_QUESTION7FULL,
      values.BOARD1_QUESTION8FULL,
      values.BOARD1_QUESTION9FULL,
      values.BOARD1_QUESTION10FULL,
      values.BOARD1_QUESTION11FULL,
      values.BOARD1_QUESTION12FULL,
      values.BOARD1_QUESTION13FULL,
      values.BOARD1_QUESTION14FULL,
      values.BOARD1_QUESTION15FULL,
      values.BOARD1_QUESTION16FULL,
      values.BOARD1_QUESTION17FULL,
      values.BOARD1_QUESTION18FULL,
    ],
    collectionRoomImagesWithoutTap: [
      {
        HD: values.BOARD1_QUESTION1FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD1_QUESTION1FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD1_QUESTION2FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD1_QUESTION2FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD1_QUESTION3FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD1_QUESTION3FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD1_QUESTION4FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD1_QUESTION4FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD1_QUESTION5FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD1_QUESTION5FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD1_QUESTION6FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD1_QUESTION6FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD1_QUESTION7FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD1_QUESTION7FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD1_QUESTION8FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD1_QUESTION8FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD1_QUESTION9FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD1_QUESTION9FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD1_QUESTION10FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD1_QUESTION10FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD1_QUESTION11FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD1_QUESTION11FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD1_QUESTION12FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD1_QUESTION12FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD1_QUESTION13FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD1_QUESTION13FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD1_QUESTION14FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD1_QUESTION14FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD1_QUESTION15FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD1_QUESTION15FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD1_QUESTION16FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD1_QUESTION16FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD1_QUESTION17FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD1_QUESTION17FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD1_QUESTION18FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD1_QUESTION18FULLWITHOUT_TAPE,
      },
    ],
    artWorkImages: [
      { HD: values.MUSIC1_HD, WEBP: values.MUSIC1 },
      { HD: values.MUSIC2_HD, WEBP: values.MUSIC2 },
      { HD: values.MUSIC3_HD, WEBP: values.MUSIC3 },
      { HD: values.MUSIC4_HD, WEBP: values.MUSIC4 },
      { HD: values.MUSIC5_HD, WEBP: values.MUSIC5 },
      { HD: values.MUSIC6_HD, WEBP: values.MUSIC6 },
      { HD: values.MUSIC7_HD, WEBP: values.MUSIC7 },
      { HD: values.MUSIC8_HD, WEBP: values.MUSIC8 },
      { HD: values.MUSIC9_HD, WEBP: values.MUSIC9 },
      { HD: values.MUSIC10_HD, WEBP: values.MUSIC10 },
    ],
    artWorkViseRoomImages: [
      { HD: values.ROOM_MUSIC1_HD, WEBP: values.ROOM_MUSIC1 },
      { HD: values.ROOM_MUSIC2_HD, WEBP: values.ROOM_MUSIC2 },
      { HD: values.ROOM_MUSIC3_HD, WEBP: values.ROOM_MUSIC3 },
      { HD: values.ROOM_MUSIC4_HD, WEBP: values.ROOM_MUSIC4 },
      { HD: values.ROOM_MUSIC5_HD, WEBP: values.ROOM_MUSIC5 },
      { HD: values.ROOM_MUSIC6_HD, WEBP: values.ROOM_MUSIC6 },
      { HD: values.ROOM_MUSIC7_HD, WEBP: values.ROOM_MUSIC7 },
      { HD: values.ROOM_MUSIC8_HD, WEBP: values.ROOM_MUSIC8 },
      { HD: values.ROOM_MUSIC9_HD, WEBP: values.ROOM_MUSIC9 },
      { HD: values.ROOM_MUSIC10_HD, WEBP: values.ROOM_MUSIC10 },
    ],
  },
  //Board2______________________________________________________________________________________
  {
    boardName: "Wildlife",
    boardNameHi: "वन्यजीव",
    boardImage: values.BOARD2,
    typeOfMarket: [
      {
        bazaarName: "HAUZ KHAS MARKET",
        bazaarNameHindi: "हौज़ ख़ास मार्किट",
        imageName: values.MARKETONENEW,
        pos1: 21,
        pos2: 22,
        pos3: 23,
        pos4: 10,
        pos5: 11,
        pos6: 12,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 1,
            id: 1,
            questionImage: values.BOARD2_QUESTION1ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD2_QUESTION1FULL,
            images: [
              {
                name: values.BOARD2_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD2_QUESTION2BLANK,
                id: "2",
              },
              {
                name: values.BOARD2_QUESTION3BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 2,
            questionImage: values.BOARD2_QUESTION2ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD2_QUESTION2FULL,
            images: [
              {
                name: values.BOARD2_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD2_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD2_QUESTION2BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 3,
            questionImage: values.BOARD2_QUESTION3ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD2_QUESTION3FULL,
            images: [
              {
                name: values.BOARD2_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD2_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD2_QUESTION5BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 1,
            questionImage: values.BOARD2_QUESTION4ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD2_QUESTION4FULL,
            images: [
              {
                name: values.BOARD2_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD2_QUESTION4BLANK,
                id: "2",
              },
              {
                name: values.BOARD2_QUESTION8BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 2,
            questionImage: values.BOARD2_QUESTION5ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD2_QUESTION5FULL,
            images: [
              {
                name: values.BOARD2_QUESTION5BLANK,
                id: "1",
              },
              {
                name: values.BOARD2_QUESTION6BLANK,
                id: "2",
              },
              {
                name: values.BOARD2_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 3,
            questionImage: values.BOARD2_QUESTION6ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD2_QUESTION6FULL,
            images: [
              {
                name: values.BOARD2_QUESTION10BLANK,
                id: "1",
              },
              {
                name: values.BOARD2_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD2_QUESTION6BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "CHOR BAZAAR",
        bazaarNameHindi: "चोर बाज़ार",
        imageName: values.MARKETTWONEW,
        pos1: 33,
        pos2: 34,
        pos3: 35,
        pos4: 30,
        pos5: 31,
        pos6: 32,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 3,
            id: 1,
            questionImage: values.BOARD2_QUESTION7ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD2_QUESTION7FULL,
            images: [
              {
                name: values.BOARD2_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD2_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD2_QUESTION14BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 2,
            questionImage: values.BOARD2_QUESTION8ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD2_QUESTION8FULL,
            images: [
              {
                name: values.BOARD2_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD2_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD2_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 3,
            questionImage: values.BOARD2_QUESTION9ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD2_QUESTION9FULL,
            images: [
              {
                name: values.BOARD2_QUESTION9BLANK,
                id: "1",
              },
              {
                name: values.BOARD2_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD2_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 1,
            questionImage: values.BOARD2_QUESTION10ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD2_QUESTION10FULL,
            images: [
              {
                name: values.BOARD2_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD2_QUESTION13BLANK,
                id: "2",
              },
              {
                name: values.BOARD2_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 2,
            questionImage: values.BOARD2_QUESTION11ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD2_QUESTION11FULL,
            images: [
              {
                name: values.BOARD2_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD2_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD2_QUESTION12BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 3,
            questionImage: values.BOARD2_QUESTION12ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD2_QUESTION12FULL,
            images: [
              {
                name: values.BOARD2_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD2_QUESTION12BLANK,
                id: "2",
              },
              {
                name: values.BOARD2_QUESTION13BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "NEHRU MARKET",
        bazaarNameHindi: "नेहरू मार्केट",
        imageName: values.MARKETTHREENEW,
        pos1: 54,
        pos2: 55,
        pos3: 43,
        pos4: 42,
        pos5: 38,
        pos6: 39,
        height: 140,
        width: 93,
        question: [
          {
            questionRound: 5,
            id: 1,
            questionImage: values.BOARD2_QUESTION13ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD2_QUESTION13FULL,
            images: [
              {
                name: values.BOARD2_QUESTION13BLANK,
                id: "1",
              },
              {
                name: values.BOARD2_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD2_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 2,
            questionImage: values.BOARD2_QUESTION14ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD2_QUESTION14FULL,
            images: [
              {
                name: values.BOARD2_QUESTION15BLANK,
                id: "1",
              },
              {
                name: values.BOARD2_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD2_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 3,
            questionImage: values.BOARD2_QUESTION15ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD2_QUESTION15FULL,
            images: [
              {
                name: values.BOARD2_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD2_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD2_QUESTION15BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 1,
            questionImage: values.BOARD2_QUESTION16ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD2_QUESTION16FULL,
            images: [
              {
                name: values.BOARD2_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD2_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD2_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 2,
            questionImage: values.BOARD2_QUESTION17ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD2_QUESTION17FULL,
            images: [
              {
                name: values.BOARD2_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD2_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD2_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 3,
            questionImage: values.BOARD2_QUESTION18ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD2_QUESTION18FULL,
            images: [
              {
                name: values.BOARD2_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD2_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD2_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
    ],
    typeOfVehicle: [
      // {
      //   door: [{ position: 64, image: values.MATCHBOX_DOOR_2 }],
      // },
      {
        train: [{ position: 45, image: values.TRAIN }],
      },
      { car: [{ position: 4, image: values.OLDCAR }] },
      {
        truck: [{ position: 28, image: values.PGNRBUS }],
      },
      { bus: [{ position: 14, image: values.REDBUS }] },
      { aeroplane: [{ position: 51, image: values.AEROPLANE }] },
      { bus2: [{ position: 59, image: values.REDBUS }] },
    ],
    gameCompleteImages: [
      { front: values.FRONTONE, back: values.BACKONE },
      { front: values.FRONTWO, back: values.BACKTWO },
      { front: values.FRONTTHREE, back: values.BACKTHREE },
      { front: values.FRONTFOUR, back: values.BACKFOUR },
    ],

    collectionRoomImages: [
      values.BOARD2_QUESTION1FULL,
      values.BOARD2_QUESTION2FULL,
      values.BOARD2_QUESTION3FULL,
      values.BOARD2_QUESTION4FULL,
      values.BOARD2_QUESTION5FULL,
      values.BOARD2_QUESTION6FULL,
      values.BOARD2_QUESTION7FULL,
      values.BOARD2_QUESTION8FULL,
      values.BOARD2_QUESTION9FULL,
      values.BOARD2_QUESTION10FULL,
      values.BOARD2_QUESTION11FULL,
      values.BOARD2_QUESTION12FULL,
      values.BOARD2_QUESTION13FULL,
      values.BOARD2_QUESTION14FULL,
      values.BOARD2_QUESTION15FULL,
      values.BOARD2_QUESTION16FULL,
      values.BOARD2_QUESTION17FULL,
      values.BOARD2_QUESTION18FULL,
    ],
    collectionRoomImagesWithoutTap: [
      {
        HD: values.BOARD2_QUESTION1FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD2_QUESTION1FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD2_QUESTION2FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD2_QUESTION2FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD2_QUESTION3FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD2_QUESTION3FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD2_QUESTION4FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD2_QUESTION4FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD2_QUESTION5FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD2_QUESTION5FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD2_QUESTION6FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD2_QUESTION6FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD2_QUESTION7FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD2_QUESTION7FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD2_QUESTION8FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD2_QUESTION8FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD2_QUESTION9FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD2_QUESTION9FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD2_QUESTION10FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD2_QUESTION10FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD2_QUESTION11FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD2_QUESTION11FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD2_QUESTION12FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD2_QUESTION12FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD2_QUESTION13FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD2_QUESTION13FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD2_QUESTION14FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD2_QUESTION14FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD2_QUESTION15FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD2_QUESTION15FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD2_QUESTION16FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD2_QUESTION16FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD2_QUESTION17FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD2_QUESTION17FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD2_QUESTION18FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD2_QUESTION18FULLWITHOUT_TAPE,
      },
    ],
    artWorkImages: [
      { HD: values.WILDLIFE1_HD, WEBP: values.WILDLIFE1 },
      { HD: values.WILDLIFE2_HD, WEBP: values.WILDLIFE2 },
      { HD: values.WILDLIFE3_HD, WEBP: values.WILDLIFE3 },
      { HD: values.WILDLIFE4_HD, WEBP: values.WILDLIFE4 },
      { HD: values.WILDLIFE5_HD, WEBP: values.WILDLIFE5 },
      { HD: values.WILDLIFE6_HD, WEBP: values.WILDLIFE6 },
      { HD: values.WILDLIFE7_HD, WEBP: values.WILDLIFE7 },
      { HD: values.WILDLIFE8_HD, WEBP: values.WILDLIFE8 },
      { HD: values.WILDLIFE9_HD, WEBP: values.WILDLIFE9 },
      { HD: values.WILDLIFE10_HD, WEBP: values.WILDLIFE10 },
    ],
    artWorkViseRoomImages: [
      { HD: values.ROOM_WILDLIFE1_HD, WEBP: values.ROOM_WILDLIFE1 },
      { HD: values.ROOM_WILDLIFE2_HD, WEBP: values.ROOM_WILDLIFE2 },
      { HD: values.ROOM_WILDLIFE3_HD, WEBP: values.ROOM_WILDLIFE3 },
      { HD: values.ROOM_WILDLIFE4_HD, WEBP: values.ROOM_WILDLIFE4 },
      { HD: values.ROOM_WILDLIFE5_HD, WEBP: values.ROOM_WILDLIFE5 },
      { HD: values.ROOM_WILDLIFE6_HD, WEBP: values.ROOM_WILDLIFE6 },
      { HD: values.ROOM_WILDLIFE7_HD, WEBP: values.ROOM_WILDLIFE7 },
      { HD: values.ROOM_WILDLIFE8_HD, WEBP: values.ROOM_WILDLIFE8 },
      { HD: values.ROOM_WILDLIFE9_HD, WEBP: values.ROOM_WILDLIFE9 },
      { HD: values.ROOM_WILDLIFE10_HD, WEBP: values.ROOM_WILDLIFE10 },
    ],
  },
  //Board3________________________________________________________________________
  {
    boardName: "Farming",
    boardNameHi: "खेती",
    boardImage: values.BOARD3,
    typeOfMarket: [
      {
        bazaarName: "HAUZ KHAS MARKET",
        bazaarNameHindi: "हौज़ ख़ास मार्किट",
        imageName: values.MARKETONENEW,
        pos1: 21,
        pos2: 22,
        pos3: 23,
        pos4: 10,
        pos5: 11,
        pos6: 12,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 1,
            id: 1,
            questionImage: values.BOARD3_QUESTION1ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD3_QUESTION1FULL,
            images: [
              {
                name: values.BOARD3_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD3_QUESTION2BLANK,
                id: "2",
              },
              {
                name: values.BOARD3_QUESTION3BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 2,
            questionImage: values.BOARD3_QUESTION2ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD3_QUESTION2FULL,
            images: [
              {
                name: values.BOARD3_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD3_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD3_QUESTION2BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 3,
            questionImage: values.BOARD3_QUESTION3ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD3_QUESTION3FULL,
            images: [
              {
                name: values.BOARD3_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD3_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD3_QUESTION5BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 1,
            questionImage: values.BOARD3_QUESTION4ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD3_QUESTION4FULL,
            images: [
              {
                name: values.BOARD3_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD3_QUESTION4BLANK,
                id: "2",
              },
              {
                name: values.BOARD3_QUESTION8BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 2,
            questionImage: values.BOARD3_QUESTION5ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD3_QUESTION5FULL,
            images: [
              {
                name: values.BOARD3_QUESTION5BLANK,
                id: "1",
              },
              {
                name: values.BOARD3_QUESTION6BLANK,
                id: "2",
              },
              {
                name: values.BOARD3_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 3,
            questionImage: values.BOARD3_QUESTION6ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD3_QUESTION6FULL,
            images: [
              {
                name: values.BOARD3_QUESTION10BLANK,
                id: "1",
              },
              {
                name: values.BOARD3_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD3_QUESTION6BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "CHOR BAZAAR",
        bazaarNameHindi: "चोर बाज़ार",
        imageName: values.MARKETTWONEW,
        pos1: 33,
        pos2: 34,
        pos3: 35,
        pos4: 30,
        pos5: 31,
        pos6: 32,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 3,
            id: 1,
            questionImage: values.BOARD3_QUESTION7ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD3_QUESTION7FULL,
            images: [
              {
                name: values.BOARD3_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD3_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD3_QUESTION14BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 2,
            questionImage: values.BOARD3_QUESTION8ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD3_QUESTION8FULL,
            images: [
              {
                name: values.BOARD3_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD3_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD3_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 3,
            questionImage: values.BOARD3_QUESTION9ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD3_QUESTION9FULL,
            images: [
              {
                name: values.BOARD3_QUESTION9BLANK,
                id: "1",
              },
              {
                name: values.BOARD3_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD3_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 1,
            questionImage: values.BOARD3_QUESTION10ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD3_QUESTION10FULL,
            images: [
              {
                name: values.BOARD3_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD3_QUESTION13BLANK,
                id: "2",
              },
              {
                name: values.BOARD3_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 2,
            questionImage: values.BOARD3_QUESTION11ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD3_QUESTION11FULL,
            images: [
              {
                name: values.BOARD3_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD3_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD3_QUESTION12BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 3,
            questionImage: values.BOARD3_QUESTION12ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD3_QUESTION12FULL,
            images: [
              {
                name: values.BOARD3_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD3_QUESTION12BLANK,
                id: "2",
              },
              {
                name: values.BOARD3_QUESTION13BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "NEHRU MARKET",
        bazaarNameHindi: "नेहरू मार्केट",
        imageName: values.MARKETTHREENEW,
        pos1: 54,
        pos2: 55,
        pos3: 43,
        pos4: 42,
        pos5: 38,
        pos6: 39,
        height: 140,
        width: 93,
        question: [
          {
            questionRound: 5,
            id: 1,
            questionImage: values.BOARD3_QUESTION13ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD3_QUESTION13FULL,
            images: [
              {
                name: values.BOARD3_QUESTION13BLANK,
                id: "1",
              },
              {
                name: values.BOARD3_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD3_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 2,
            questionImage: values.BOARD3_QUESTION14ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD3_QUESTION14FULL,
            images: [
              {
                name: values.BOARD3_QUESTION15BLANK,
                id: "1",
              },
              {
                name: values.BOARD3_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD3_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 3,
            questionImage: values.BOARD3_QUESTION15ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD3_QUESTION15FULL,
            images: [
              {
                name: values.BOARD3_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD3_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD3_QUESTION15BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 1,
            questionImage: values.BOARD3_QUESTION16ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD3_QUESTION16FULL,
            images: [
              {
                name: values.BOARD3_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD3_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD3_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 2,
            questionImage: values.BOARD3_QUESTION17ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD3_QUESTION17FULL,
            images: [
              {
                name: values.BOARD3_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD3_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD3_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 3,
            questionImage: values.BOARD3_QUESTION18ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD3_QUESTION18FULL,
            images: [
              {
                name: values.BOARD3_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD3_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD3_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
    ],
    typeOfVehicle: [
      // {
      //   door: [{ position: 64, image: values.MATCHBOX_DOOR_2 }],
      // },
      {
        train: [{ position: 45, image: values.TRAIN }],
      },
      { car: [{ position: 4, image: values.OLDCAR }] },
      {
        truck: [{ position: 28, image: values.PGNRBUS }],
      },
      { bus: [{ position: 14, image: values.REDBUS }] },
      { aeroplane: [{ position: 51, image: values.AEROPLANE }] },
      { bus2: [{ position: 59, image: values.REDBUS }] },
    ],
    gameCompleteImages: [
      { front: values.FRONTONE, back: values.BACKONE },
      { front: values.FRONTWO, back: values.BACKTWO },
      { front: values.FRONTTHREE, back: values.BACKTHREE },
      { front: values.FRONTFOUR, back: values.BACKFOUR },
    ],

    collectionRoomImages: [
      values.BOARD3_QUESTION1FULL,
      values.BOARD3_QUESTION2FULL,
      values.BOARD3_QUESTION3FULL,
      values.BOARD3_QUESTION4FULL,
      values.BOARD3_QUESTION5FULL,
      values.BOARD3_QUESTION6FULL,
      values.BOARD3_QUESTION7FULL,
      values.BOARD3_QUESTION8FULL,
      values.BOARD3_QUESTION9FULL,
      values.BOARD3_QUESTION10FULL,
      values.BOARD3_QUESTION11FULL,
      values.BOARD3_QUESTION12FULL,
      values.BOARD3_QUESTION13FULL,
      values.BOARD3_QUESTION14FULL,
      values.BOARD3_QUESTION15FULL,
      values.BOARD3_QUESTION16FULL,
      values.BOARD3_QUESTION17FULL,
      values.BOARD3_QUESTION18FULL,
    ],
    collectionRoomImagesWithoutTap: [
      {
        HD: values.BOARD3_QUESTION1FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD3_QUESTION1FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD3_QUESTION2FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD3_QUESTION2FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD3_QUESTION3FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD3_QUESTION3FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD3_QUESTION4FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD3_QUESTION4FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD3_QUESTION5FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD3_QUESTION5FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD3_QUESTION6FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD3_QUESTION6FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD3_QUESTION7FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD3_QUESTION7FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD3_QUESTION8FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD3_QUESTION8FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD3_QUESTION9FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD3_QUESTION9FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD3_QUESTION10FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD3_QUESTION10FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD3_QUESTION11FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD3_QUESTION11FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD3_QUESTION12FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD3_QUESTION12FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD3_QUESTION13FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD3_QUESTION13FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD3_QUESTION14FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD3_QUESTION14FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD3_QUESTION15FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD3_QUESTION15FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD3_QUESTION16FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD3_QUESTION16FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD3_QUESTION17FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD3_QUESTION17FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD3_QUESTION18FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD3_QUESTION18FULLWITHOUT_TAPE,
      },
    ],
    artWorkImages: [
      { HD: values.FARMING1_HD, WEBP: values.FARMING1 },
      { HD: values.FARMING2_HD, WEBP: values.FARMING2 },
      { HD: values.FARMING3_HD, WEBP: values.FARMING3 },
      { HD: values.FARMING4_HD, WEBP: values.FARMING4 },
      { HD: values.FARMING5_HD, WEBP: values.FARMING5 },
      { HD: values.FARMING6_HD, WEBP: values.FARMING6 },
      { HD: values.FARMING7_HD, WEBP: values.FARMING7 },
      { HD: values.FARMING8_HD, WEBP: values.FARMING8 },
      { HD: values.FARMING9_HD, WEBP: values.FARMING9 },
      { HD: values.FARMING10_HD, WEBP: values.FARMING10 },
    ],
    artWorkViseRoomImages: [
      { HD: values.ROOM_FARMING1_HD, WEBP: values.ROOM_FARMING1 },
      { HD: values.ROOM_FARMING2_HD, WEBP: values.ROOM_FARMING2 },
      { HD: values.ROOM_FARMING3_HD, WEBP: values.ROOM_FARMING3 },
      { HD: values.ROOM_FARMING4_HD, WEBP: values.ROOM_FARMING4 },
      { HD: values.ROOM_FARMING5_HD, WEBP: values.ROOM_FARMING5 },
      { HD: values.ROOM_FARMING6_HD, WEBP: values.ROOM_FARMING6 },
      { HD: values.ROOM_FARMING7_HD, WEBP: values.ROOM_FARMING7 },
      { HD: values.ROOM_FARMING8_HD, WEBP: values.ROOM_FARMING8 },
      { HD: values.ROOM_FARMING9_HD, WEBP: values.ROOM_FARMING9 },
      { HD: values.ROOM_FARMING10_HD, WEBP: values.ROOM_FARMING10 },
    ],
  },
  //Board 4
  {
    boardName: "Tools",
    boardNameHi: "औज़ार",
    boardImage: values.BOARD4,
    typeOfMarket: [
      {
        bazaarName: "HAUZ KHAS MARKET",
        bazaarNameHindi: "हौज़ ख़ास मार्किट",
        imageName: values.MARKETONENEW,
        pos1: 21,
        pos2: 22,
        pos3: 23,
        pos4: 10,
        pos5: 11,
        pos6: 12,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 1,
            id: 1,
            questionImage: values.BOARD4_QUESTION1ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD4_QUESTION1FULL,
            images: [
              {
                name: values.BOARD4_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD4_QUESTION2BLANK,
                id: "2",
              },
              {
                name: values.BOARD4_QUESTION3BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 2,
            questionImage: values.BOARD4_QUESTION2ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD4_QUESTION2FULL,
            images: [
              {
                name: values.BOARD4_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD4_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD4_QUESTION2BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 3,
            questionImage: values.BOARD4_QUESTION3ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD4_QUESTION3FULL,
            images: [
              {
                name: values.BOARD4_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD4_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD4_QUESTION5BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 1,
            questionImage: values.BOARD4_QUESTION4ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD4_QUESTION4FULL,
            images: [
              {
                name: values.BOARD4_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD4_QUESTION4BLANK,
                id: "2",
              },
              {
                name: values.BOARD4_QUESTION8BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 2,
            questionImage: values.BOARD4_QUESTION5ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD4_QUESTION5FULL,
            images: [
              {
                name: values.BOARD4_QUESTION5BLANK,
                id: "1",
              },
              {
                name: values.BOARD4_QUESTION6BLANK,
                id: "2",
              },
              {
                name: values.BOARD4_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 3,
            questionImage: values.BOARD4_QUESTION6ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD4_QUESTION6FULL,
            images: [
              {
                name: values.BOARD4_QUESTION10BLANK,
                id: "1",
              },
              {
                name: values.BOARD4_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD4_QUESTION6BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "CHOR BAZAAR",
        bazaarNameHindi: "चोर बाज़ार",
        imageName: values.MARKETTWONEW,
        pos1: 33,
        pos2: 34,
        pos3: 35,
        pos4: 30,
        pos5: 31,
        pos6: 32,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 3,
            id: 1,
            questionImage: values.BOARD4_QUESTION7ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD4_QUESTION7FULL,
            images: [
              {
                name: values.BOARD4_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD4_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD4_QUESTION14BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 2,
            questionImage: values.BOARD4_QUESTION8ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD4_QUESTION8FULL,
            images: [
              {
                name: values.BOARD4_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD4_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD4_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 3,
            questionImage: values.BOARD4_QUESTION9ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD4_QUESTION9FULL,
            images: [
              {
                name: values.BOARD4_QUESTION9BLANK,
                id: "1",
              },
              {
                name: values.BOARD4_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD4_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 1,
            questionImage: values.BOARD4_QUESTION10ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD4_QUESTION10FULL,
            images: [
              {
                name: values.BOARD4_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD4_QUESTION13BLANK,
                id: "2",
              },
              {
                name: values.BOARD4_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 2,
            questionImage: values.BOARD4_QUESTION11ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD4_QUESTION11FULL,
            images: [
              {
                name: values.BOARD4_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD4_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD4_QUESTION12BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 3,
            questionImage: values.BOARD4_QUESTION12ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD4_QUESTION12FULL,
            images: [
              {
                name: values.BOARD4_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD4_QUESTION12BLANK,
                id: "2",
              },
              {
                name: values.BOARD4_QUESTION13BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "NEHRU MARKET",
        bazaarNameHindi: "नेहरू मार्केट",
        imageName: values.MARKETTHREENEW,
        pos1: 54,
        pos2: 55,
        pos3: 43,
        pos4: 42,
        pos5: 38,
        pos6: 39,
        height: 140,
        width: 93,
        question: [
          {
            questionRound: 5,
            id: 1,
            questionImage: values.BOARD4_QUESTION13ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD4_QUESTION13FULL,
            images: [
              {
                name: values.BOARD4_QUESTION13BLANK,
                id: "1",
              },
              {
                name: values.BOARD4_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD4_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 2,
            questionImage: values.BOARD4_QUESTION14ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD4_QUESTION14FULL,
            images: [
              {
                name: values.BOARD4_QUESTION15BLANK,
                id: "1",
              },
              {
                name: values.BOARD4_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD4_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 3,
            questionImage: values.BOARD4_QUESTION15ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD4_QUESTION15FULL,
            images: [
              {
                name: values.BOARD4_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD4_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD4_QUESTION15BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 1,
            questionImage: values.BOARD4_QUESTION16ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD4_QUESTION16FULL,
            images: [
              {
                name: values.BOARD4_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD4_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD4_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 2,
            questionImage: values.BOARD4_QUESTION17ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD4_QUESTION17FULL,
            images: [
              {
                name: values.BOARD4_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD4_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD4_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 3,
            questionImage: values.BOARD4_QUESTION18ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD4_QUESTION18FULL,
            images: [
              {
                name: values.BOARD4_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD4_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD4_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
    ],
    typeOfVehicle: [
      // {
      //   door: [{ position: 64, image: values.MATCHBOX_DOOR_2 }],
      // },
      {
        train: [{ position: 45, image: values.TRAIN }],
      },
      { car: [{ position: 4, image: values.OLDCAR }] },
      {
        truck: [{ position: 28, image: values.PGNRBUS }],
      },
      { bus: [{ position: 14, image: values.REDBUS }] },
      { aeroplane: [{ position: 51, image: values.AEROPLANE }] },
      { bus2: [{ position: 59, image: values.REDBUS }] },
    ],
    gameCompleteImages: [
      { front: values.FRONTONE, back: values.BACKONE },
      { front: values.FRONTWO, back: values.BACKTWO },
      { front: values.FRONTTHREE, back: values.BACKTHREE },
      { front: values.FRONTFOUR, back: values.BACKFOUR },
    ],

    collectionRoomImages: [
      values.BOARD4_QUESTION1FULL,
      values.BOARD4_QUESTION2FULL,
      values.BOARD4_QUESTION3FULL,
      values.BOARD4_QUESTION4FULL,
      values.BOARD4_QUESTION5FULL,
      values.BOARD4_QUESTION6FULL,
      values.BOARD4_QUESTION7FULL,
      values.BOARD4_QUESTION8FULL,
      values.BOARD4_QUESTION9FULL,
      values.BOARD4_QUESTION10FULL,
      values.BOARD4_QUESTION11FULL,
      values.BOARD4_QUESTION12FULL,
      values.BOARD4_QUESTION13FULL,
      values.BOARD4_QUESTION14FULL,
      values.BOARD4_QUESTION15FULL,
      values.BOARD4_QUESTION16FULL,
      values.BOARD4_QUESTION17FULL,
      values.BOARD4_QUESTION18FULL,
    ],
    collectionRoomImagesWithoutTap: [
      {
        HD: values.BOARD4_QUESTION1FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD4_QUESTION1FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD4_QUESTION2FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD4_QUESTION2FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD4_QUESTION3FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD4_QUESTION3FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD4_QUESTION4FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD4_QUESTION4FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD4_QUESTION5FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD4_QUESTION5FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD4_QUESTION6FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD4_QUESTION6FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD4_QUESTION7FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD4_QUESTION7FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD4_QUESTION8FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD4_QUESTION8FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD4_QUESTION9FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD4_QUESTION9FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD4_QUESTION10FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD4_QUESTION10FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD4_QUESTION11FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD4_QUESTION11FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD4_QUESTION12FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD4_QUESTION12FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD4_QUESTION13FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD4_QUESTION13FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD4_QUESTION14FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD4_QUESTION14FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD4_QUESTION15FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD4_QUESTION15FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD4_QUESTION16FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD4_QUESTION16FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD4_QUESTION17FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD4_QUESTION17FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD4_QUESTION18FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD4_QUESTION18FULLWITHOUT_TAPE,
      },
    ],
    artWorkImages: [
      { HD: values.TOOLS1_HD, WEBP: values.TOOLS1 },
      { HD: values.TOOLS2_HD, WEBP: values.TOOLS2 },
      { HD: values.TOOLS3_HD, WEBP: values.TOOLS3 },
      { HD: values.TOOLS4_HD, WEBP: values.TOOLS4 },
      { HD: values.TOOLS5_HD, WEBP: values.TOOLS5 },
      { HD: values.TOOLS6_HD, WEBP: values.TOOLS6 },
      { HD: values.TOOLS7_HD, WEBP: values.TOOLS7 },
      { HD: values.TOOLS8_HD, WEBP: values.TOOLS8 },
      { HD: values.TOOLS9_HD, WEBP: values.TOOLS9 },
      { HD: values.TOOLS10_HD, WEBP: values.TOOLS10 },
    ],
    artWorkViseRoomImages: [
      { HD: values.ROOM_TOOLS1_HD, WEBP: values.ROOM_TOOLS1 },
      { HD: values.ROOM_TOOLS2_HD, WEBP: values.ROOM_TOOLS2 },
      { HD: values.ROOM_TOOLS3_HD, WEBP: values.ROOM_TOOLS3 },
      { HD: values.ROOM_TOOLS4_HD, WEBP: values.ROOM_TOOLS4 },
      { HD: values.ROOM_TOOLS5_HD, WEBP: values.ROOM_TOOLS5 },
      { HD: values.ROOM_TOOLS6_HD, WEBP: values.ROOM_TOOLS6 },
      { HD: values.ROOM_TOOLS7_HD, WEBP: values.ROOM_TOOLS7 },
      { HD: values.ROOM_TOOLS8_HD, WEBP: values.ROOM_TOOLS8 },
      { HD: values.ROOM_TOOLS9_HD, WEBP: values.ROOM_TOOLS9 },
      { HD: values.ROOM_TOOLS10_HD, WEBP: values.ROOM_TOOLS10 },
    ],
  },
  //Board 5
  {
    boardName: "Symbols",
    boardNameHi: "प्रतीक",
    boardImage: values.BOARD5,
    typeOfMarket: [
      {
        bazaarName: "HAUZ KHAS MARKET",
        bazaarNameHindi: "हौज़ ख़ास मार्किट",
        imageName: values.MARKETONENEW,
        pos1: 21,
        pos2: 22,
        pos3: 23,
        pos4: 10,
        pos5: 11,
        pos6: 12,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 1,
            id: 1,
            questionImage: values.BOARD5_QUESTION1ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD5_QUESTION1FULL,
            images: [
              {
                name: values.BOARD5_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD5_QUESTION2BLANK,
                id: "2",
              },
              {
                name: values.BOARD5_QUESTION3BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 2,
            questionImage: values.BOARD5_QUESTION2ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD5_QUESTION2FULL,
            images: [
              {
                name: values.BOARD5_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD5_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD5_QUESTION2BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 3,
            questionImage: values.BOARD5_QUESTION3ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD5_QUESTION3FULL,
            images: [
              {
                name: values.BOARD5_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD5_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD5_QUESTION5BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 1,
            questionImage: values.BOARD5_QUESTION4ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD5_QUESTION4FULL,
            images: [
              {
                name: values.BOARD5_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD5_QUESTION4BLANK,
                id: "2",
              },
              {
                name: values.BOARD5_QUESTION8BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 2,
            questionImage: values.BOARD5_QUESTION5ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD5_QUESTION5FULL,
            images: [
              {
                name: values.BOARD5_QUESTION5BLANK,
                id: "1",
              },
              {
                name: values.BOARD5_QUESTION6BLANK,
                id: "2",
              },
              {
                name: values.BOARD5_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 3,
            questionImage: values.BOARD5_QUESTION6ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD5_QUESTION6FULL,
            images: [
              {
                name: values.BOARD5_QUESTION10BLANK,
                id: "1",
              },
              {
                name: values.BOARD5_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD5_QUESTION6BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "CHOR BAZAAR",
        bazaarNameHindi: "चोर बाज़ार",
        imageName: values.MARKETTWONEW,
        pos1: 33,
        pos2: 34,
        pos3: 35,
        pos4: 30,
        pos5: 31,
        pos6: 32,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 3,
            id: 1,
            questionImage: values.BOARD5_QUESTION7ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD5_QUESTION7FULL,
            images: [
              {
                name: values.BOARD5_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD5_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD5_QUESTION14BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 2,
            questionImage: values.BOARD5_QUESTION8ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD5_QUESTION8FULL,
            images: [
              {
                name: values.BOARD5_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD5_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD5_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 3,
            questionImage: values.BOARD5_QUESTION9ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD5_QUESTION9FULL,
            images: [
              {
                name: values.BOARD5_QUESTION9BLANK,
                id: "1",
              },
              {
                name: values.BOARD5_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD5_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 1,
            questionImage: values.BOARD5_QUESTION10ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD5_QUESTION10FULL,
            images: [
              {
                name: values.BOARD5_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD5_QUESTION13BLANK,
                id: "2",
              },
              {
                name: values.BOARD5_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 2,
            questionImage: values.BOARD5_QUESTION11ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD5_QUESTION11FULL,
            images: [
              {
                name: values.BOARD5_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD5_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD5_QUESTION12BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 3,
            questionImage: values.BOARD5_QUESTION12ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD5_QUESTION12FULL,
            images: [
              {
                name: values.BOARD5_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD5_QUESTION12BLANK,
                id: "2",
              },
              {
                name: values.BOARD5_QUESTION13BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "NEHRU MARKET",
        bazaarNameHindi: "नेहरू मार्केट",
        imageName: values.MARKETTHREENEW,
        pos1: 54,
        pos2: 55,
        pos3: 43,
        pos4: 42,
        pos5: 38,
        pos6: 39,
        height: 140,
        width: 93,
        question: [
          {
            questionRound: 5,
            id: 1,
            questionImage: values.BOARD5_QUESTION13ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD5_QUESTION13FULL,
            images: [
              {
                name: values.BOARD5_QUESTION13BLANK,
                id: "1",
              },
              {
                name: values.BOARD5_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD5_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 2,
            questionImage: values.BOARD5_QUESTION14ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD5_QUESTION14FULL,
            images: [
              {
                name: values.BOARD5_QUESTION15BLANK,
                id: "1",
              },
              {
                name: values.BOARD5_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD5_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 3,
            questionImage: values.BOARD5_QUESTION15ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD5_QUESTION15FULL,
            images: [
              {
                name: values.BOARD5_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD5_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD5_QUESTION15BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 1,
            questionImage: values.BOARD5_QUESTION16ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD5_QUESTION16FULL,
            images: [
              {
                name: values.BOARD5_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD5_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD5_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 2,
            questionImage: values.BOARD5_QUESTION17ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD5_QUESTION17FULL,
            images: [
              {
                name: values.BOARD5_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD5_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD5_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 3,
            questionImage: values.BOARD5_QUESTION18ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD5_QUESTION18FULL,
            images: [
              {
                name: values.BOARD5_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD5_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD5_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
    ],
    typeOfVehicle: [
      // {
      //   door: [{ position: 64, image: values.MATCHBOX_DOOR_2 }],
      // },
      {
        train: [{ position: 45, image: values.TRAIN }],
      },
      { car: [{ position: 4, image: values.OLDCAR }] },
      {
        truck: [{ position: 28, image: values.PGNRBUS }],
      },
      { bus: [{ position: 14, image: values.REDBUS }] },
      { aeroplane: [{ position: 51, image: values.AEROPLANE }] },
      { bus2: [{ position: 59, image: values.REDBUS }] },
    ],
    gameCompleteImages: [
      { front: values.FRONTONE, back: values.BACKONE },
      { front: values.FRONTWO, back: values.BACKTWO },
      { front: values.FRONTTHREE, back: values.BACKTHREE },
      { front: values.FRONTFOUR, back: values.BACKFOUR },
    ],

    collectionRoomImages: [
      values.BOARD5_QUESTION1FULL,
      values.BOARD5_QUESTION2FULL,
      values.BOARD5_QUESTION3FULL,
      values.BOARD5_QUESTION4FULL,
      values.BOARD5_QUESTION5FULL,
      values.BOARD5_QUESTION6FULL,
      values.BOARD5_QUESTION7FULL,
      values.BOARD5_QUESTION8FULL,
      values.BOARD5_QUESTION9FULL,
      values.BOARD5_QUESTION10FULL,
      values.BOARD5_QUESTION11FULL,
      values.BOARD5_QUESTION12FULL,
      values.BOARD5_QUESTION13FULL,
      values.BOARD5_QUESTION14FULL,
      values.BOARD5_QUESTION15FULL,
      values.BOARD5_QUESTION16FULL,
      values.BOARD5_QUESTION17FULL,
      values.BOARD5_QUESTION18FULL,
    ],
    collectionRoomImagesWithoutTap: [
      {
        HD: values.BOARD5_QUESTION1FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD5_QUESTION1FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD5_QUESTION2FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD5_QUESTION2FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD5_QUESTION3FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD5_QUESTION3FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD5_QUESTION4FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD5_QUESTION4FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD5_QUESTION5FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD5_QUESTION5FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD5_QUESTION6FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD5_QUESTION6FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD5_QUESTION7FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD5_QUESTION7FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD5_QUESTION8FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD5_QUESTION8FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD5_QUESTION9FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD5_QUESTION9FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD5_QUESTION10FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD5_QUESTION10FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD5_QUESTION11FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD5_QUESTION11FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD5_QUESTION12FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD5_QUESTION12FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD5_QUESTION13FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD5_QUESTION13FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD5_QUESTION14FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD5_QUESTION14FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD5_QUESTION15FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD5_QUESTION15FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD5_QUESTION16FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD5_QUESTION16FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD5_QUESTION17FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD5_QUESTION17FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD5_QUESTION18FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD5_QUESTION18FULLWITHOUT_TAPE,
      },
    ],
    artWorkImages: [
      { HD: values.SYMBOLS1_HD, WEBP: values.SYMBOLS1 },
      { HD: values.SYMBOLS2_HD, WEBP: values.SYMBOLS2 },
      { HD: values.SYMBOLS3_HD, WEBP: values.SYMBOLS3 },
      { HD: values.SYMBOLS4_HD, WEBP: values.SYMBOLS4 },
      { HD: values.SYMBOLS5_HD, WEBP: values.SYMBOLS5 },
      { HD: values.SYMBOLS6_HD, WEBP: values.SYMBOLS6 },
      { HD: values.SYMBOLS7_HD, WEBP: values.SYMBOLS7 },
      { HD: values.SYMBOLS8_HD, WEBP: values.SYMBOLS8 },
      { HD: values.SYMBOLS9_HD, WEBP: values.SYMBOLS9 },
      { HD: values.SYMBOLS10_HD, WEBP: values.SYMBOLS10 },
    ],
    artWorkViseRoomImages: [
      { HD: values.ROOM_SYMBOLS1_HD, WEBP: values.ROOM_SYMBOLS1 },
      { HD: values.ROOM_SYMBOLS2_HD, WEBP: values.ROOM_SYMBOLS2 },
      { HD: values.ROOM_SYMBOLS3_HD, WEBP: values.ROOM_SYMBOLS3 },
      { HD: values.ROOM_SYMBOLS4_HD, WEBP: values.ROOM_SYMBOLS4 },
      { HD: values.ROOM_SYMBOLS5_HD, WEBP: values.ROOM_SYMBOLS5 },
      { HD: values.ROOM_SYMBOLS6_HD, WEBP: values.ROOM_SYMBOLS6 },
      { HD: values.ROOM_SYMBOLS7_HD, WEBP: values.ROOM_SYMBOLS7 },
      { HD: values.ROOM_SYMBOLS8_HD, WEBP: values.ROOM_SYMBOLS8 },
      { HD: values.ROOM_SYMBOLS9_HD, WEBP: values.ROOM_SYMBOLS9 },
      { HD: values.ROOM_SYMBOLS10_HD, WEBP: values.ROOM_SYMBOLS10 },
    ],
  },
  //Board 6
  {
    boardName: "Sports",
    boardNameHi: "खेल",
    boardImage: values.BOARD6,
    typeOfMarket: [
      {
        bazaarName: "HAUZ KHAS MARKET",
        bazaarNameHindi: "हौज़ ख़ास मार्किट",
        imageName: values.MARKETONENEW,
        pos1: 20,
        pos2: 21,
        pos3: 22,
        pos4: 11,
        pos5: 12,
        pos6: 13,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 1,
            id: 1,
            questionImage: values.BOARD6_QUESTION1ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD6_QUESTION1FULL,
            images: [
              {
                name: values.BOARD6_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD6_QUESTION2BLANK,
                id: "2",
              },
              {
                name: values.BOARD6_QUESTION3BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 2,
            questionImage: values.BOARD6_QUESTION2ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD6_QUESTION2FULL,
            images: [
              {
                name: values.BOARD6_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD6_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD6_QUESTION2BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 3,
            questionImage: values.BOARD6_QUESTION3ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD6_QUESTION3FULL,
            images: [
              {
                name: values.BOARD6_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD6_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD6_QUESTION5BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 1,
            questionImage: values.BOARD6_QUESTION4ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD6_QUESTION4FULL,
            images: [
              {
                name: values.BOARD6_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD6_QUESTION4BLANK,
                id: "2",
              },
              {
                name: values.BOARD6_QUESTION8BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 2,
            questionImage: values.BOARD6_QUESTION5ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD6_QUESTION5FULL,
            images: [
              {
                name: values.BOARD6_QUESTION5BLANK,
                id: "1",
              },
              {
                name: values.BOARD6_QUESTION6BLANK,
                id: "2",
              },
              {
                name: values.BOARD6_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 3,
            questionImage: values.BOARD6_QUESTION6ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD6_QUESTION6FULL,
            images: [
              {
                name: values.BOARD6_QUESTION10BLANK,
                id: "1",
              },
              {
                name: values.BOARD6_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD6_QUESTION6BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "CHOR BAZAAR",
        bazaarNameHindi: "चोर बाज़ार",
        imageName: values.MARKETTWONEW,
        pos1: 33,
        pos2: 34,
        pos3: 35,
        pos4: 30,
        pos5: 31,
        pos6: 32,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 3,
            id: 1,
            questionImage: values.BOARD6_QUESTION7ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD6_QUESTION7FULL,
            images: [
              {
                name: values.BOARD6_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD6_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD6_QUESTION14BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 2,
            questionImage: values.BOARD6_QUESTION8ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD6_QUESTION8FULL,
            images: [
              {
                name: values.BOARD6_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD6_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD6_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 3,
            questionImage: values.BOARD6_QUESTION9ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD6_QUESTION9FULL,
            images: [
              {
                name: values.BOARD6_QUESTION9BLANK,
                id: "1",
              },
              {
                name: values.BOARD6_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD6_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 1,
            questionImage: values.BOARD6_QUESTION10ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD6_QUESTION10FULL,
            images: [
              {
                name: values.BOARD6_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD6_QUESTION13BLANK,
                id: "2",
              },
              {
                name: values.BOARD6_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 2,
            questionImage: values.BOARD6_QUESTION11ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD6_QUESTION11FULL,
            images: [
              {
                name: values.BOARD6_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD6_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD6_QUESTION12BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 3,
            questionImage: values.BOARD6_QUESTION12ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD6_QUESTION12FULL,
            images: [
              {
                name: values.BOARD6_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD6_QUESTION12BLANK,
                id: "2",
              },
              {
                name: values.BOARD6_QUESTION13BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "NEHRU MARKET",
        bazaarNameHindi: "नेहरू मार्केट",
        imageName: values.MARKETTHREENEW,
        pos1: 54,
        pos2: 55,
        pos3: 43,
        pos4: 42,
        pos5: 38,
        pos6: 39,
        height: 140,
        width: 93,
        question: [
          {
            questionRound: 5,
            id: 1,
            questionImage: values.BOARD6_QUESTION13ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD6_QUESTION13FULL,
            images: [
              {
                name: values.BOARD6_QUESTION13BLANK,
                id: "1",
              },
              {
                name: values.BOARD6_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD6_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 2,
            questionImage: values.BOARD6_QUESTION14ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD6_QUESTION14FULL,
            images: [
              {
                name: values.BOARD6_QUESTION15BLANK,
                id: "1",
              },
              {
                name: values.BOARD6_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD6_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 3,
            questionImage: values.BOARD6_QUESTION15ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD6_QUESTION15FULL,
            images: [
              {
                name: values.BOARD6_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD6_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD6_QUESTION15BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 1,
            questionImage: values.BOARD6_QUESTION16ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD6_QUESTION16FULL,
            images: [
              {
                name: values.BOARD6_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD6_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD6_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 2,
            questionImage: values.BOARD6_QUESTION17ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD6_QUESTION17FULL,
            images: [
              {
                name: values.BOARD6_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD6_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD6_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 3,
            questionImage: values.BOARD6_QUESTION18ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD6_QUESTION18FULL,
            images: [
              {
                name: values.BOARD6_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD6_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD6_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
    ],
    typeOfVehicle: [
      // {
      //   door: [{ position: 64, image: values.MATCHBOX_DOOR_2 }],
      // },
      {
        train: [{ position: 45, image: values.TRAIN }],
      },
      { car: [{ position: 4, image: values.OLDCAR }] },
      {
        truck: [{ position: 28, image: values.PGNRBUS }],
      },
      { bus: [{ position: 14, image: values.REDBUS }] },
      { aeroplane: [{ position: 51, image: values.AEROPLANE }] },
      { bus2: [{ position: 59, image: values.REDBUS }] },
    ],
    gameCompleteImages: [
      { front: values.FRONTONE, back: values.BACKONE },
      { front: values.FRONTWO, back: values.BACKTWO },
      { front: values.FRONTTHREE, back: values.BACKTHREE },
      { front: values.FRONTFOUR, back: values.BACKFOUR },
    ],

    collectionRoomImages: [
      values.BOARD6_QUESTION1FULL,
      values.BOARD6_QUESTION2FULL,
      values.BOARD6_QUESTION3FULL,
      values.BOARD6_QUESTION4FULL,
      values.BOARD6_QUESTION5FULL,
      values.BOARD6_QUESTION6FULL,
      values.BOARD6_QUESTION7FULL,
      values.BOARD6_QUESTION8FULL,
      values.BOARD6_QUESTION9FULL,
      values.BOARD6_QUESTION10FULL,
      values.BOARD6_QUESTION11FULL,
      values.BOARD6_QUESTION12FULL,
      values.BOARD6_QUESTION13FULL,
      values.BOARD6_QUESTION14FULL,
      values.BOARD6_QUESTION15FULL,
      values.BOARD6_QUESTION16FULL,
      values.BOARD6_QUESTION17FULL,
      values.BOARD6_QUESTION18FULL,
    ],
    collectionRoomImagesWithoutTap: [
      {
        HD: values.BOARD6_QUESTION1FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD6_QUESTION1FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD6_QUESTION2FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD6_QUESTION2FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD6_QUESTION3FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD6_QUESTION3FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD6_QUESTION4FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD6_QUESTION4FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD6_QUESTION5FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD6_QUESTION5FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD6_QUESTION6FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD6_QUESTION6FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD6_QUESTION7FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD6_QUESTION7FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD6_QUESTION8FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD6_QUESTION8FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD6_QUESTION9FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD6_QUESTION9FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD6_QUESTION10FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD6_QUESTION10FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD6_QUESTION11FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD6_QUESTION11FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD6_QUESTION12FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD6_QUESTION12FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD6_QUESTION13FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD6_QUESTION13FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD6_QUESTION14FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD6_QUESTION14FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD6_QUESTION15FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD6_QUESTION15FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD6_QUESTION16FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD6_QUESTION16FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD6_QUESTION17FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD6_QUESTION17FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD6_QUESTION18FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD6_QUESTION18FULLWITHOUT_TAPE,
      },
    ],
    artWorkImages: [
      { HD: values.SPORTS1_HD, WEBP: values.SPORTS1 },
      { HD: values.SPORTS2_HD, WEBP: values.SPORTS2 },
      { HD: values.SPORTS3_HD, WEBP: values.SPORTS3 },
      { HD: values.SPORTS4_HD, WEBP: values.SPORTS4 },
      { HD: values.SPORTS5_HD, WEBP: values.SPORTS5 },
      { HD: values.SPORTS6_HD, WEBP: values.SPORTS6 },
      { HD: values.SPORTS7_HD, WEBP: values.SPORTS7 },
      { HD: values.SPORTS8_HD, WEBP: values.SPORTS8 },
      { HD: values.SPORTS9_HD, WEBP: values.SPORTS9 },
      { HD: values.SPORTS10_HD, WEBP: values.SPORTS10 },
    ],
    artWorkViseRoomImages: [
      { HD: values.ROOM_SPORTS1_HD, WEBP: values.ROOM_SPORTS1 },
      { HD: values.ROOM_SPORTS2_HD, WEBP: values.ROOM_SPORTS2 },
      { HD: values.ROOM_SPORTS3_HD, WEBP: values.ROOM_SPORTS3 },
      { HD: values.ROOM_SPORTS4_HD, WEBP: values.ROOM_SPORTS4 },
      { HD: values.ROOM_SPORTS5_HD, WEBP: values.ROOM_SPORTS5 },
      { HD: values.ROOM_SPORTS6_HD, WEBP: values.ROOM_SPORTS6 },
      { HD: values.ROOM_SPORTS7_HD, WEBP: values.ROOM_SPORTS7 },
      { HD: values.ROOM_SPORTS8_HD, WEBP: values.ROOM_SPORTS8 },
      { HD: values.ROOM_SPORTS9_HD, WEBP: values.ROOM_SPORTS9 },
      { HD: values.ROOM_SPORTS10_HD, WEBP: values.ROOM_SPORTS10 },
    ],
  },
  //Board 7
  {
    boardName: "Women",
    boardNameHi: "महिला",
    boardImage: values.BOARD7,
    typeOfMarket: [
      {
        bazaarName: "HAUZ KHAS MARKET",
        bazaarNameHindi: "हौज़ ख़ास मार्किट",
        imageName: values.MARKETONENEW,
        pos1: 21,
        pos2: 22,
        pos3: 23,
        pos4: 10,
        pos5: 11,
        pos6: 12,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 1,
            id: 1,
            questionImage: values.BOARD7_QUESTION1ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD7_QUESTION1FULL,
            images: [
              {
                name: values.BOARD7_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD7_QUESTION2BLANK,
                id: "2",
              },
              {
                name: values.BOARD7_QUESTION3BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 2,
            questionImage: values.BOARD7_QUESTION2ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD7_QUESTION2FULL,
            images: [
              {
                name: values.BOARD7_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD7_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD7_QUESTION2BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 3,
            questionImage: values.BOARD7_QUESTION3ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD7_QUESTION3FULL,
            images: [
              {
                name: values.BOARD7_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD7_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD7_QUESTION5BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 1,
            questionImage: values.BOARD7_QUESTION4ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD7_QUESTION4FULL,
            images: [
              {
                name: values.BOARD7_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD7_QUESTION4BLANK,
                id: "2",
              },
              {
                name: values.BOARD7_QUESTION8BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 2,
            questionImage: values.BOARD7_QUESTION5ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD7_QUESTION5FULL,
            images: [
              {
                name: values.BOARD7_QUESTION5BLANK,
                id: "1",
              },
              {
                name: values.BOARD7_QUESTION6BLANK,
                id: "2",
              },
              {
                name: values.BOARD7_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 3,
            questionImage: values.BOARD7_QUESTION6ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD7_QUESTION6FULL,
            images: [
              {
                name: values.BOARD7_QUESTION10BLANK,
                id: "1",
              },
              {
                name: values.BOARD7_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD7_QUESTION6BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "CHOR BAZAAR",
        bazaarNameHindi: "चोर बाज़ार",
        imageName: values.MARKETTWONEW,
        pos1: 33,
        pos2: 34,
        pos3: 35,
        pos4: 30,
        pos5: 31,
        pos6: 32,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 3,
            id: 1,
            questionImage: values.BOARD7_QUESTION7ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD7_QUESTION7FULL,
            images: [
              {
                name: values.BOARD7_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD7_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD7_QUESTION14BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 2,
            questionImage: values.BOARD7_QUESTION8ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD7_QUESTION8FULL,
            images: [
              {
                name: values.BOARD7_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD7_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD7_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 3,
            questionImage: values.BOARD7_QUESTION9ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD7_QUESTION9FULL,
            images: [
              {
                name: values.BOARD7_QUESTION9BLANK,
                id: "1",
              },
              {
                name: values.BOARD7_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD7_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 1,
            questionImage: values.BOARD7_QUESTION10ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD7_QUESTION10FULL,
            images: [
              {
                name: values.BOARD7_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD7_QUESTION13BLANK,
                id: "2",
              },
              {
                name: values.BOARD7_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 2,
            questionImage: values.BOARD7_QUESTION11ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD7_QUESTION11FULL,
            images: [
              {
                name: values.BOARD7_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD7_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD7_QUESTION12BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 3,
            questionImage: values.BOARD7_QUESTION12ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD7_QUESTION12FULL,
            images: [
              {
                name: values.BOARD7_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD7_QUESTION12BLANK,
                id: "2",
              },
              {
                name: values.BOARD7_QUESTION13BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "NEHRU MARKET",
        bazaarNameHindi: "नेहरू मार्केट",
        imageName: values.MARKETTHREENEW,
        pos1: 54,
        pos2: 55,
        pos3: 43,
        pos4: 42,
        pos5: 38,
        pos6: 39,
        height: 140,
        width: 93,
        question: [
          {
            questionRound: 5,
            id: 1,
            questionImage: values.BOARD7_QUESTION13ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD7_QUESTION13FULL,
            images: [
              {
                name: values.BOARD7_QUESTION13BLANK,
                id: "1",
              },
              {
                name: values.BOARD7_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD7_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 2,
            questionImage: values.BOARD7_QUESTION14ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD7_QUESTION14FULL,
            images: [
              {
                name: values.BOARD7_QUESTION15BLANK,
                id: "1",
              },
              {
                name: values.BOARD7_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD7_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 3,
            questionImage: values.BOARD7_QUESTION15ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD7_QUESTION15FULL,
            images: [
              {
                name: values.BOARD7_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD7_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD7_QUESTION15BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 1,
            questionImage: values.BOARD7_QUESTION16ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD7_QUESTION16FULL,
            images: [
              {
                name: values.BOARD7_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD7_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD7_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 2,
            questionImage: values.BOARD7_QUESTION17ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD7_QUESTION17FULL,
            images: [
              {
                name: values.BOARD7_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD7_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD7_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 3,
            questionImage: values.BOARD7_QUESTION18ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD7_QUESTION18FULL,
            images: [
              {
                name: values.BOARD7_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD7_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD7_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
    ],
    typeOfVehicle: [
      // {
      //   door: [{ position: 64, image: values.MATCHBOX_DOOR_2 }],
      // },
      {
        train: [{ position: 45, image: values.TRAIN }],
      },
      { car: [{ position: 4, image: values.OLDCAR }] },
      {
        truck: [{ position: 28, image: values.PGNRBUS }],
      },
      { bus: [{ position: 14, image: values.REDBUS }] },
      { aeroplane: [{ position: 51, image: values.AEROPLANE }] },
      { bus2: [{ position: 59, image: values.REDBUS }] },
    ],
    gameCompleteImages: [
      { front: values.FRONTONE, back: values.BACKONE },
      { front: values.FRONTWO, back: values.BACKTWO },
      { front: values.FRONTTHREE, back: values.BACKTHREE },
      { front: values.FRONTFOUR, back: values.BACKFOUR },
    ],

    collectionRoomImages: [
      values.BOARD7_QUESTION1FULL,
      values.BOARD7_QUESTION2FULL,
      values.BOARD7_QUESTION3FULL,
      values.BOARD7_QUESTION4FULL,
      values.BOARD7_QUESTION5FULL,
      values.BOARD7_QUESTION6FULL,
      values.BOARD7_QUESTION7FULL,
      values.BOARD7_QUESTION8FULL,
      values.BOARD7_QUESTION9FULL,
      values.BOARD7_QUESTION10FULL,
      values.BOARD7_QUESTION11FULL,
      values.BOARD7_QUESTION12FULL,
      values.BOARD7_QUESTION13FULL,
      values.BOARD7_QUESTION14FULL,
      values.BOARD7_QUESTION15FULL,
      values.BOARD7_QUESTION16FULL,
      values.BOARD7_QUESTION17FULL,
      values.BOARD7_QUESTION18FULL,
    ],
    collectionRoomImagesWithoutTap: [
      {
        HD: values.BOARD7_QUESTION1FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD7_QUESTION1FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD7_QUESTION2FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD7_QUESTION2FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD7_QUESTION3FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD7_QUESTION3FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD7_QUESTION4FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD7_QUESTION4FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD7_QUESTION5FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD7_QUESTION5FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD7_QUESTION6FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD7_QUESTION6FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD7_QUESTION7FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD7_QUESTION7FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD7_QUESTION8FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD7_QUESTION8FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD7_QUESTION9FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD7_QUESTION9FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD7_QUESTION10FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD7_QUESTION10FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD7_QUESTION11FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD7_QUESTION11FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD7_QUESTION12FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD7_QUESTION12FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD7_QUESTION13FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD7_QUESTION13FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD7_QUESTION14FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD7_QUESTION14FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD7_QUESTION15FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD7_QUESTION15FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD7_QUESTION16FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD7_QUESTION16FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD7_QUESTION17FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD7_QUESTION17FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD7_QUESTION18FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD7_QUESTION18FULLWITHOUT_TAPE,
      },
    ],
    artWorkImages: [
      { HD: values.WOMEN1_HD, WEBP: values.WOMEN1 },
      { HD: values.WOMEN2_HD, WEBP: values.WOMEN2 },
      { HD: values.WOMEN3_HD, WEBP: values.WOMEN3 },
      { HD: values.WOMEN4_HD, WEBP: values.WOMEN4 },
      { HD: values.WOMEN5_HD, WEBP: values.WOMEN5 },
      { HD: values.WOMEN6_HD, WEBP: values.WOMEN6 },
      { HD: values.WOMEN7_HD, WEBP: values.WOMEN7 },
      { HD: values.WOMEN8_HD, WEBP: values.WOMEN8 },
      { HD: values.WOMEN9_HD, WEBP: values.WOMEN9 },
      { HD: values.WOMEN10_HD, WEBP: values.WOMEN10 },
    ],
    artWorkViseRoomImages: [
      { HD: values.ROOM_WOMEN1_HD, WEBP: values.ROOM_WOMEN1 },
      { HD: values.ROOM_WOMEN2_HD, WEBP: values.ROOM_WOMEN2 },
      { HD: values.ROOM_WOMEN3_HD, WEBP: values.ROOM_WOMEN3 },
      { HD: values.ROOM_WOMEN4_HD, WEBP: values.ROOM_WOMEN4 },
      { HD: values.ROOM_WOMEN5_HD, WEBP: values.ROOM_WOMEN5 },
      { HD: values.ROOM_WOMEN6_HD, WEBP: values.ROOM_WOMEN6 },
      { HD: values.ROOM_WOMEN7_HD, WEBP: values.ROOM_WOMEN7 },
      { HD: values.ROOM_WOMEN8_HD, WEBP: values.ROOM_WOMEN8 },
      { HD: values.ROOM_WOMEN9_HD, WEBP: values.ROOM_WOMEN9 },
      { HD: values.ROOM_WOMEN10_HD, WEBP: values.ROOM_WOMEN10 },
    ],
  },
  //Board 8
  {
    boardName: "Men",
    boardNameHi: "पुरुष",
    boardImage: values.BOARD8,
    typeOfMarket: [
      {
        bazaarName: "HAUZ KHAS MARKET",
        bazaarNameHindi: "हौज़ ख़ास मार्किट",
        imageName: values.MARKETONENEW,
        pos1: 21,
        pos2: 22,
        pos3: 23,
        pos4: 10,
        pos5: 11,
        pos6: 12,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 1,
            id: 1,
            questionImage: values.BOARD8_QUESTION1ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD8_QUESTION1FULL,
            images: [
              {
                name: values.BOARD8_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD8_QUESTION2BLANK,
                id: "2",
              },
              {
                name: values.BOARD8_QUESTION3BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 2,
            questionImage: values.BOARD8_QUESTION2ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD8_QUESTION2FULL,
            images: [
              {
                name: values.BOARD8_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD8_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD8_QUESTION2BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 3,
            questionImage: values.BOARD8_QUESTION3ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD8_QUESTION3FULL,
            images: [
              {
                name: values.BOARD8_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD8_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD8_QUESTION5BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 1,
            questionImage: values.BOARD8_QUESTION4ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD8_QUESTION4FULL,
            images: [
              {
                name: values.BOARD8_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD8_QUESTION4BLANK,
                id: "2",
              },
              {
                name: values.BOARD8_QUESTION8BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 2,
            questionImage: values.BOARD8_QUESTION5ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD8_QUESTION5FULL,
            images: [
              {
                name: values.BOARD8_QUESTION5BLANK,
                id: "1",
              },
              {
                name: values.BOARD8_QUESTION6BLANK,
                id: "2",
              },
              {
                name: values.BOARD8_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 3,
            questionImage: values.BOARD8_QUESTION6ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD8_QUESTION6FULL,
            images: [
              {
                name: values.BOARD8_QUESTION10BLANK,
                id: "1",
              },
              {
                name: values.BOARD8_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD8_QUESTION6BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "CHOR BAZAAR",
        bazaarNameHindi: "चोर बाज़ार",
        imageName: values.MARKETTWONEW,
        pos1: 33,
        pos2: 34,
        pos3: 35,
        pos4: 30,
        pos5: 31,
        pos6: 32,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 3,
            id: 1,
            questionImage: values.BOARD8_QUESTION7ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD8_QUESTION7FULL,
            images: [
              {
                name: values.BOARD8_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD8_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD8_QUESTION14BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 2,
            questionImage: values.BOARD8_QUESTION8ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD8_QUESTION8FULL,
            images: [
              {
                name: values.BOARD8_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD8_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD8_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 3,
            questionImage: values.BOARD8_QUESTION9ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD8_QUESTION9FULL,
            images: [
              {
                name: values.BOARD8_QUESTION9BLANK,
                id: "1",
              },
              {
                name: values.BOARD8_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD8_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 1,
            questionImage: values.BOARD8_QUESTION10ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD8_QUESTION10FULL,
            images: [
              {
                name: values.BOARD8_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD8_QUESTION13BLANK,
                id: "2",
              },
              {
                name: values.BOARD8_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 2,
            questionImage: values.BOARD8_QUESTION11ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD8_QUESTION11FULL,
            images: [
              {
                name: values.BOARD8_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD8_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD8_QUESTION12BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 3,
            questionImage: values.BOARD8_QUESTION12ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD8_QUESTION12FULL,
            images: [
              {
                name: values.BOARD8_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD8_QUESTION12BLANK,
                id: "2",
              },
              {
                name: values.BOARD8_QUESTION13BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "NEHRU MARKET",
        bazaarNameHindi: "नेहरू मार्केट",
        imageName: values.MARKETTHREENEW,
        pos1: 54,
        pos2: 55,
        pos3: 43,
        pos4: 42,
        pos5: 38,
        pos6: 39,
        height: 140,
        width: 93,
        question: [
          {
            questionRound: 5,
            id: 1,
            questionImage: values.BOARD8_QUESTION13ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD8_QUESTION13FULL,
            images: [
              {
                name: values.BOARD8_QUESTION13BLANK,
                id: "1",
              },
              {
                name: values.BOARD8_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD8_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 2,
            questionImage: values.BOARD8_QUESTION14ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD8_QUESTION14FULL,
            images: [
              {
                name: values.BOARD8_QUESTION15BLANK,
                id: "1",
              },
              {
                name: values.BOARD8_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD8_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 3,
            questionImage: values.BOARD8_QUESTION15ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD8_QUESTION15FULL,
            images: [
              {
                name: values.BOARD8_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD8_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD8_QUESTION15BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 1,
            questionImage: values.BOARD8_QUESTION16ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD8_QUESTION16FULL,
            images: [
              {
                name: values.BOARD8_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD8_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD8_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 2,
            questionImage: values.BOARD8_QUESTION17ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD8_QUESTION17FULL,
            images: [
              {
                name: values.BOARD8_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD8_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD8_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 3,
            questionImage: values.BOARD8_QUESTION18ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD8_QUESTION18FULL,
            images: [
              {
                name: values.BOARD8_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD8_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD8_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
    ],
    typeOfVehicle: [
      // {
      //   door: [{ position: 64, image: values.MATCHBOX_DOOR_2 }],
      // },
      {
        train: [{ position: 45, image: values.TRAIN }],
      },
      { car: [{ position: 4, image: values.OLDCAR }] },
      {
        truck: [{ position: 28, image: values.PGNRBUS }],
      },
      { bus: [{ position: 14, image: values.REDBUS }] },
      { aeroplane: [{ position: 51, image: values.AEROPLANE }] },
      { bus2: [{ position: 59, image: values.REDBUS }] },
    ],
    gameCompleteImages: [
      { front: values.FRONTONE, back: values.BACKONE },
      { front: values.FRONTWO, back: values.BACKTWO },
      { front: values.FRONTTHREE, back: values.BACKTHREE },
      { front: values.FRONTFOUR, back: values.BACKFOUR },
    ],

    collectionRoomImages: [
      values.BOARD8_QUESTION1FULL,
      values.BOARD8_QUESTION2FULL,
      values.BOARD8_QUESTION3FULL,
      values.BOARD8_QUESTION4FULL,
      values.BOARD8_QUESTION5FULL,
      values.BOARD8_QUESTION6FULL,
      values.BOARD8_QUESTION7FULL,
      values.BOARD8_QUESTION8FULL,
      values.BOARD8_QUESTION9FULL,
      values.BOARD8_QUESTION10FULL,
      values.BOARD8_QUESTION11FULL,
      values.BOARD8_QUESTION12FULL,
      values.BOARD8_QUESTION13FULL,
      values.BOARD8_QUESTION14FULL,
      values.BOARD8_QUESTION15FULL,
      values.BOARD8_QUESTION16FULL,
      values.BOARD8_QUESTION17FULL,
      values.BOARD8_QUESTION18FULL,
    ],
    collectionRoomImagesWithoutTap: [
      {
        HD: values.BOARD8_QUESTION1FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD8_QUESTION1FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD8_QUESTION2FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD8_QUESTION2FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD8_QUESTION3FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD8_QUESTION3FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD8_QUESTION4FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD8_QUESTION4FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD8_QUESTION5FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD8_QUESTION5FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD8_QUESTION6FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD8_QUESTION6FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD8_QUESTION7FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD8_QUESTION7FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD8_QUESTION8FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD8_QUESTION8FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD8_QUESTION9FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD8_QUESTION9FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD8_QUESTION10FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD8_QUESTION10FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD8_QUESTION11FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD8_QUESTION11FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD8_QUESTION12FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD8_QUESTION12FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD8_QUESTION13FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD8_QUESTION13FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD8_QUESTION14FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD8_QUESTION14FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD8_QUESTION15FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD8_QUESTION15FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD8_QUESTION16FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD8_QUESTION16FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD8_QUESTION17FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD8_QUESTION17FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD8_QUESTION18FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD8_QUESTION18FULLWITHOUT_TAPE,
      },
    ],
    artWorkImages: [
      { HD: values.MEN1_HD, WEBP: values.MEN1 },
      { HD: values.MEN2_HD, WEBP: values.MEN2 },
      { HD: values.MEN3_HD, WEBP: values.MEN3 },
      { HD: values.MEN4_HD, WEBP: values.MEN4 },
      { HD: values.MEN5_HD, WEBP: values.MEN5 },
      { HD: values.MEN6_HD, WEBP: values.MEN6 },
      { HD: values.MEN7_HD, WEBP: values.MEN7 },
      { HD: values.MEN8_HD, WEBP: values.MEN8 },
      { HD: values.MEN9_HD, WEBP: values.MEN9 },
      { HD: values.MEN10_HD, WEBP: values.MEN10 },
    ],
    artWorkViseRoomImages: [
      { HD: values.ROOM_MEN1_HD, WEBP: values.ROOM_MEN1 },
      { HD: values.ROOM_MEN2_HD, WEBP: values.ROOM_MEN2 },
      { HD: values.ROOM_MEN3_HD, WEBP: values.ROOM_MEN3 },
      { HD: values.ROOM_MEN4_HD, WEBP: values.ROOM_MEN4 },
      { HD: values.ROOM_MEN5_HD, WEBP: values.ROOM_MEN5 },
      { HD: values.ROOM_MEN6_HD, WEBP: values.ROOM_MEN6 },
      { HD: values.ROOM_MEN7_HD, WEBP: values.ROOM_MEN7 },
      { HD: values.ROOM_MEN8_HD, WEBP: values.ROOM_MEN8 },
      { HD: values.ROOM_MEN9_HD, WEBP: values.ROOM_MEN9 },
      { HD: values.ROOM_MEN10_HD, WEBP: values.ROOM_MEN10 },
    ],
  },
  //Board 9
  {
    boardName: "India",
    boardNameHi: "भारत",
    boardImage: values.BOARD9,
    typeOfMarket: [
      {
        bazaarName: "HAUZ KHAS MARKET",
        bazaarNameHindi: "हौज़ ख़ास मार्किट",
        imageName: values.MARKETONENEW,
        pos1: 21,
        pos2: 22,
        pos3: 23,
        pos4: 10,
        pos5: 11,
        pos6: 12,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 1,
            id: 1,
            questionImage: values.BOARD9_QUESTION1ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD9_QUESTION1FULL,
            images: [
              {
                name: values.BOARD9_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD9_QUESTION2BLANK,
                id: "2",
              },
              {
                name: values.BOARD9_QUESTION3BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 2,
            questionImage: values.BOARD9_QUESTION2ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD9_QUESTION2FULL,
            images: [
              {
                name: values.BOARD9_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD9_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD9_QUESTION2BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 3,
            questionImage: values.BOARD9_QUESTION3ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD9_QUESTION3FULL,
            images: [
              {
                name: values.BOARD9_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD9_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD9_QUESTION5BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 1,
            questionImage: values.BOARD9_QUESTION4ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD9_QUESTION4FULL,
            images: [
              {
                name: values.BOARD9_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD9_QUESTION4BLANK,
                id: "2",
              },
              {
                name: values.BOARD9_QUESTION8BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 2,
            questionImage: values.BOARD9_QUESTION5ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD9_QUESTION5FULL,
            images: [
              {
                name: values.BOARD9_QUESTION5BLANK,
                id: "1",
              },
              {
                name: values.BOARD9_QUESTION6BLANK,
                id: "2",
              },
              {
                name: values.BOARD9_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 3,
            questionImage: values.BOARD9_QUESTION6ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD9_QUESTION6FULL,
            images: [
              {
                name: values.BOARD9_QUESTION10BLANK,
                id: "1",
              },
              {
                name: values.BOARD9_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD9_QUESTION6BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "CHOR BAZAAR",
        bazaarNameHindi: "चोर बाज़ार",
        imageName: values.MARKETTWONEW,
        pos1: 33,
        pos2: 34,
        pos3: 35,
        pos4: 30,
        pos5: 31,
        pos6: 32,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 3,
            id: 1,
            questionImage: values.BOARD9_QUESTION7ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD9_QUESTION7FULL,
            images: [
              {
                name: values.BOARD9_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD9_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD9_QUESTION14BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 2,
            questionImage: values.BOARD9_QUESTION8ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD9_QUESTION8FULL,
            images: [
              {
                name: values.BOARD9_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD9_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD9_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 3,
            questionImage: values.BOARD9_QUESTION9ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD9_QUESTION9FULL,
            images: [
              {
                name: values.BOARD9_QUESTION9BLANK,
                id: "1",
              },
              {
                name: values.BOARD9_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD9_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 1,
            questionImage: values.BOARD9_QUESTION10ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD9_QUESTION10FULL,
            images: [
              {
                name: values.BOARD9_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD9_QUESTION13BLANK,
                id: "2",
              },
              {
                name: values.BOARD9_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 2,
            questionImage: values.BOARD9_QUESTION11ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD9_QUESTION11FULL,
            images: [
              {
                name: values.BOARD9_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD9_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD9_QUESTION12BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 3,
            questionImage: values.BOARD9_QUESTION12ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD9_QUESTION12FULL,
            images: [
              {
                name: values.BOARD9_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD9_QUESTION12BLANK,
                id: "2",
              },
              {
                name: values.BOARD9_QUESTION13BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "NEHRU MARKET",
        bazaarNameHindi: "नेहरू मार्केट",
        imageName: values.MARKETTHREENEW,
        pos1: 54,
        pos2: 55,
        pos3: 43,
        pos4: 42,
        pos5: 38,
        pos6: 39,
        height: 140,
        width: 93,
        question: [
          {
            questionRound: 5,
            id: 1,
            questionImage: values.BOARD9_QUESTION13ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD9_QUESTION13FULL,
            images: [
              {
                name: values.BOARD9_QUESTION13BLANK,
                id: "1",
              },
              {
                name: values.BOARD9_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD9_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 2,
            questionImage: values.BOARD9_QUESTION14ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD9_QUESTION14FULL,
            images: [
              {
                name: values.BOARD9_QUESTION15BLANK,
                id: "1",
              },
              {
                name: values.BOARD9_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD9_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 3,
            questionImage: values.BOARD9_QUESTION15ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD9_QUESTION15FULL,
            images: [
              {
                name: values.BOARD9_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD9_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD9_QUESTION15BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 1,
            questionImage: values.BOARD9_QUESTION16ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD9_QUESTION16FULL,
            images: [
              {
                name: values.BOARD9_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD9_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD9_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 2,
            questionImage: values.BOARD9_QUESTION17ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD9_QUESTION17FULL,
            images: [
              {
                name: values.BOARD9_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD9_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD9_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 3,
            questionImage: values.BOARD9_QUESTION18ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD9_QUESTION18FULL,
            images: [
              {
                name: values.BOARD9_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD9_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD9_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
    ],
    typeOfVehicle: [
      // {
      //   door: [{ position: 64, image: values.MATCHBOX_DOOR_2 }],
      // },
      {
        train: [{ position: 45, image: values.TRAIN }],
      },
      { car: [{ position: 4, image: values.OLDCAR }] },
      {
        truck: [{ position: 28, image: values.PGNRBUS }],
      },
      { bus: [{ position: 14, image: values.REDBUS }] },
      { aeroplane: [{ position: 51, image: values.AEROPLANE }] },
      { bus2: [{ position: 59, image: values.REDBUS }] },
    ],
    gameCompleteImages: [
      { front: values.FRONTONE, back: values.BACKONE },
      { front: values.FRONTWO, back: values.BACKTWO },
      { front: values.FRONTTHREE, back: values.BACKTHREE },
      { front: values.FRONTFOUR, back: values.BACKFOUR },
    ],

    collectionRoomImages: [
      values.BOARD9_QUESTION1FULL,
      values.BOARD9_QUESTION2FULL,
      values.BOARD9_QUESTION3FULL,
      values.BOARD9_QUESTION4FULL,
      values.BOARD9_QUESTION5FULL,
      values.BOARD9_QUESTION6FULL,
      values.BOARD9_QUESTION7FULL,
      values.BOARD9_QUESTION8FULL,
      values.BOARD9_QUESTION9FULL,
      values.BOARD9_QUESTION10FULL,
      values.BOARD9_QUESTION11FULL,
      values.BOARD9_QUESTION12FULL,
      values.BOARD9_QUESTION13FULL,
      values.BOARD9_QUESTION14FULL,
      values.BOARD9_QUESTION15FULL,
      values.BOARD9_QUESTION16FULL,
      values.BOARD9_QUESTION17FULL,
      values.BOARD9_QUESTION18FULL,
    ],
    collectionRoomImagesWithoutTap: [
      {
        HD: values.BOARD9_QUESTION1FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD9_QUESTION1FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD9_QUESTION2FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD9_QUESTION2FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD9_QUESTION3FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD9_QUESTION3FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD9_QUESTION4FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD9_QUESTION4FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD9_QUESTION5FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD9_QUESTION5FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD9_QUESTION6FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD9_QUESTION6FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD9_QUESTION7FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD9_QUESTION7FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD9_QUESTION8FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD9_QUESTION8FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD9_QUESTION9FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD9_QUESTION9FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD9_QUESTION10FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD9_QUESTION10FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD9_QUESTION11FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD9_QUESTION11FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD9_QUESTION12FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD9_QUESTION12FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD9_QUESTION13FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD9_QUESTION13FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD9_QUESTION14FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD9_QUESTION14FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD9_QUESTION15FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD9_QUESTION15FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD9_QUESTION16FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD9_QUESTION16FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD9_QUESTION17FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD9_QUESTION17FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD9_QUESTION18FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD9_QUESTION18FULLWITHOUT_TAPE,
      },
    ],
    artWorkImages: [
      { HD: values.INDIA1_HD, WEBP: values.INDIA1 },
      { HD: values.INDIA2_HD, WEBP: values.INDIA2 },
      { HD: values.INDIA3_HD, WEBP: values.INDIA3 },
      { HD: values.INDIA4_HD, WEBP: values.INDIA4 },
      { HD: values.INDIA5_HD, WEBP: values.INDIA5 },
      { HD: values.INDIA6_HD, WEBP: values.INDIA6 },
      { HD: values.INDIA7_HD, WEBP: values.INDIA7 },
      { HD: values.INDIA8_HD, WEBP: values.INDIA8 },
      { HD: values.INDIA9_HD, WEBP: values.INDIA9 },
      { HD: values.INDIA10_HD, WEBP: values.INDIA10 },
    ],
    artWorkViseRoomImages: [
      { HD: values.ROOM_INDIA1_HD, WEBP: values.ROOM_INDIA1 },
      { HD: values.ROOM_INDIA2_HD, WEBP: values.ROOM_INDIA2 },
      { HD: values.ROOM_INDIA3_HD, WEBP: values.ROOM_INDIA3 },
      { HD: values.ROOM_INDIA4_HD, WEBP: values.ROOM_INDIA4 },
      { HD: values.ROOM_INDIA5_HD, WEBP: values.ROOM_INDIA5 },
      { HD: values.ROOM_INDIA6_HD, WEBP: values.ROOM_INDIA6 },
      { HD: values.ROOM_INDIA7_HD, WEBP: values.ROOM_INDIA7 },
      { HD: values.ROOM_INDIA8_HD, WEBP: values.ROOM_INDIA8 },
      { HD: values.ROOM_INDIA9_HD, WEBP: values.ROOM_INDIA9 },
      { HD: values.ROOM_INDIA10_HD, WEBP: values.ROOM_INDIA10 },
    ],
  },
  //Board 10
  {
    boardName: "Transport",
    boardNameHi: "परिवहन",
    boardImage: values.BOARD10,
    typeOfMarket: [
      {
        bazaarName: "HAUZ KHAS MARKET",
        bazaarNameHindi: "हौज़ ख़ास मार्किट",
        imageName: values.MARKETONENEW,
        pos1: 21,
        pos2: 22,
        pos3: 23,
        pos4: 10,
        pos5: 11,
        pos6: 12,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 1,
            id: 1,
            questionImage: values.BOARD10_QUESTION1ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD10_QUESTION1FULL,
            images: [
              {
                name: values.BOARD10_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD10_QUESTION2BLANK,
                id: "2",
              },
              {
                name: values.BOARD10_QUESTION3BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 2,
            questionImage: values.BOARD10_QUESTION2ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD10_QUESTION2FULL,
            images: [
              {
                name: values.BOARD10_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD10_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD10_QUESTION2BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 3,
            questionImage: values.BOARD10_QUESTION3ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD10_QUESTION3FULL,
            images: [
              {
                name: values.BOARD10_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD10_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD10_QUESTION5BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 1,
            questionImage: values.BOARD10_QUESTION4ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD10_QUESTION4FULL,
            images: [
              {
                name: values.BOARD10_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD10_QUESTION4BLANK,
                id: "2",
              },
              {
                name: values.BOARD10_QUESTION8BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 2,
            questionImage: values.BOARD10_QUESTION5ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD10_QUESTION5FULL,
            images: [
              {
                name: values.BOARD10_QUESTION5BLANK,
                id: "1",
              },
              {
                name: values.BOARD10_QUESTION6BLANK,
                id: "2",
              },
              {
                name: values.BOARD10_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 3,
            questionImage: values.BOARD10_QUESTION6ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD10_QUESTION6FULL,
            images: [
              {
                name: values.BOARD10_QUESTION10BLANK,
                id: "1",
              },
              {
                name: values.BOARD10_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD10_QUESTION6BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "CHOR BAZAAR",
        bazaarNameHindi: "चोर बाज़ार",
        imageName: values.MARKETTWONEW,
        pos1: 33,
        pos2: 34,
        pos3: 35,
        pos4: 30,
        pos5: 31,
        pos6: 32,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 3,
            id: 1,
            questionImage: values.BOARD10_QUESTION7ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD10_QUESTION7FULL,
            images: [
              {
                name: values.BOARD10_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD10_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD10_QUESTION14BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 2,
            questionImage: values.BOARD10_QUESTION8ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD10_QUESTION8FULL,
            images: [
              {
                name: values.BOARD10_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD10_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD10_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 3,
            questionImage: values.BOARD10_QUESTION9ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD10_QUESTION9FULL,
            images: [
              {
                name: values.BOARD10_QUESTION9BLANK,
                id: "1",
              },
              {
                name: values.BOARD10_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD10_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 1,
            questionImage: values.BOARD10_QUESTION10ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD10_QUESTION10FULL,
            images: [
              {
                name: values.BOARD10_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD10_QUESTION13BLANK,
                id: "2",
              },
              {
                name: values.BOARD10_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 2,
            questionImage: values.BOARD10_QUESTION11ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD10_QUESTION11FULL,
            images: [
              {
                name: values.BOARD10_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD10_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD10_QUESTION12BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 3,
            questionImage: values.BOARD10_QUESTION12ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD10_QUESTION12FULL,
            images: [
              {
                name: values.BOARD10_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD10_QUESTION12BLANK,
                id: "2",
              },
              {
                name: values.BOARD10_QUESTION13BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "NEHRU MARKET",
        bazaarNameHindi: "नेहरू मार्केट",
        imageName: values.MARKETTHREENEW,
        pos1: 54,
        pos2: 55,
        pos3: 43,
        pos4: 42,
        pos5: 38,
        pos6: 39,
        height: 140,
        width: 93,
        question: [
          {
            questionRound: 5,
            id: 1,
            questionImage: values.BOARD10_QUESTION13ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD10_QUESTION13FULL,
            images: [
              {
                name: values.BOARD10_QUESTION13BLANK,
                id: "1",
              },
              {
                name: values.BOARD10_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD10_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 2,
            questionImage: values.BOARD10_QUESTION14ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD10_QUESTION14FULL,
            images: [
              {
                name: values.BOARD10_QUESTION15BLANK,
                id: "1",
              },
              {
                name: values.BOARD10_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD10_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 3,
            questionImage: values.BOARD10_QUESTION15ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD10_QUESTION15FULL,
            images: [
              {
                name: values.BOARD10_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD10_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD10_QUESTION15BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 1,
            questionImage: values.BOARD10_QUESTION16ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD10_QUESTION16FULL,
            images: [
              {
                name: values.BOARD10_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD10_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD10_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 2,
            questionImage: values.BOARD10_QUESTION17ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD10_QUESTION17FULL,
            images: [
              {
                name: values.BOARD10_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD10_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD10_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 3,
            questionImage: values.BOARD10_QUESTION18ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD10_QUESTION18FULL,
            images: [
              {
                name: values.BOARD10_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD10_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD10_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
    ],
    typeOfVehicle: [
      // {
      //   door: [{ position: 64, image: values.MATCHBOX_DOOR_2 }],
      // },
      {
        train: [{ position: 45, image: values.TRAIN }],
      },
      { car: [{ position: 4, image: values.OLDCAR }] },
      {
        truck: [{ position: 28, image: values.PGNRBUS }],
      },
      { bus: [{ position: 14, image: values.REDBUS }] },
      { aeroplane: [{ position: 51, image: values.AEROPLANE }] },
      { bus2: [{ position: 59, image: values.REDBUS }] },
    ],
    gameCompleteImages: [
      { front: values.FRONTONE, back: values.BACKONE },
      { front: values.FRONTWO, back: values.BACKTWO },
      { front: values.FRONTTHREE, back: values.BACKTHREE },
      { front: values.FRONTFOUR, back: values.BACKFOUR },
    ],

    collectionRoomImages: [
      values.BOARD10_QUESTION1FULL,
      values.BOARD10_QUESTION2FULL,
      values.BOARD10_QUESTION3FULL,
      values.BOARD10_QUESTION4FULL,
      values.BOARD10_QUESTION5FULL,
      values.BOARD10_QUESTION6FULL,
      values.BOARD10_QUESTION7FULL,
      values.BOARD10_QUESTION8FULL,
      values.BOARD10_QUESTION9FULL,
      values.BOARD10_QUESTION10FULL,
      values.BOARD10_QUESTION11FULL,
      values.BOARD10_QUESTION12FULL,
      values.BOARD10_QUESTION13FULL,
      values.BOARD10_QUESTION14FULL,
      values.BOARD10_QUESTION15FULL,
      values.BOARD10_QUESTION16FULL,
      values.BOARD10_QUESTION17FULL,
      values.BOARD10_QUESTION18FULL,
    ],
    collectionRoomImagesWithoutTap: [
      {
        HD: values.BOARD10_QUESTION1FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD10_QUESTION1FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD10_QUESTION2FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD10_QUESTION2FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD10_QUESTION3FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD10_QUESTION3FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD10_QUESTION4FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD10_QUESTION4FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD10_QUESTION5FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD10_QUESTION5FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD10_QUESTION6FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD10_QUESTION6FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD10_QUESTION7FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD10_QUESTION7FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD10_QUESTION8FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD10_QUESTION8FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD10_QUESTION9FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD10_QUESTION9FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD10_QUESTION10FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD10_QUESTION10FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD10_QUESTION11FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD10_QUESTION11FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD10_QUESTION12FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD10_QUESTION12FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD10_QUESTION13FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD10_QUESTION13FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD10_QUESTION14FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD10_QUESTION14FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD10_QUESTION15FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD10_QUESTION15FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD10_QUESTION16FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD10_QUESTION16FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD10_QUESTION17FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD10_QUESTION17FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD10_QUESTION18FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD10_QUESTION18FULLWITHOUT_TAPE,
      },
    ],
    artWorkImages: [
      { HD: values.TRANSPORT1_HD, WEBP: values.TRANSPORT1 },
      { HD: values.TRANSPORT2_HD, WEBP: values.TRANSPORT2 },
      { HD: values.TRANSPORT3_HD, WEBP: values.TRANSPORT3 },
      { HD: values.TRANSPORT4_HD, WEBP: values.TRANSPORT4 },
      { HD: values.TRANSPORT5_HD, WEBP: values.TRANSPORT5 },
      { HD: values.TRANSPORT6_HD, WEBP: values.TRANSPORT6 },
      { HD: values.TRANSPORT7_HD, WEBP: values.TRANSPORT7 },
      { HD: values.TRANSPORT8_HD, WEBP: values.TRANSPORT8 },
      { HD: values.TRANSPORT9_HD, WEBP: values.TRANSPORT9 },
      { HD: values.TRANSPORT10_HD, WEBP: values.TRANSPORT10 },
    ],
    artWorkViseRoomImages: [
      { HD: values.ROOM_TRANSPORT1_HD, WEBP: values.ROOM_TRANSPORT1 },
      { HD: values.ROOM_TRANSPORT2_HD, WEBP: values.ROOM_TRANSPORT2 },
      { HD: values.ROOM_TRANSPORT3_HD, WEBP: values.ROOM_TRANSPORT3 },
      { HD: values.ROOM_TRANSPORT4_HD, WEBP: values.ROOM_TRANSPORT4 },
      { HD: values.ROOM_TRANSPORT5_HD, WEBP: values.ROOM_TRANSPORT5 },
      { HD: values.ROOM_TRANSPORT6_HD, WEBP: values.ROOM_TRANSPORT6 },
      { HD: values.ROOM_TRANSPORT7_HD, WEBP: values.ROOM_TRANSPORT7 },
      { HD: values.ROOM_TRANSPORT8_HD, WEBP: values.ROOM_TRANSPORT8 },
      { HD: values.ROOM_TRANSPORT9_HD, WEBP: values.ROOM_TRANSPORT9 },
      { HD: values.ROOM_TRANSPORT10_HD, WEBP: values.ROOM_TRANSPORT10 },
    ],
  },
  //Board 11
  {
    boardName: "Flowers",
    boardNameHi: "फूल",
    boardImage: values.BOARD11,
    typeOfMarket: [
      {
        bazaarName: "HAUZ KHAS MARKET",
        bazaarNameHindi: "हौज़ ख़ास मार्किट",
        imageName: values.MARKETONENEW,
        pos1: 21,
        pos2: 22,
        pos3: 23,
        pos4: 10,
        pos5: 11,
        pos6: 12,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 1,
            id: 1,
            questionImage: values.BOARD11_QUESTION1ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD11_QUESTION1FULL,
            images: [
              {
                name: values.BOARD11_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD11_QUESTION2BLANK,
                id: "2",
              },
              {
                name: values.BOARD11_QUESTION3BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 2,
            questionImage: values.BOARD11_QUESTION2ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD11_QUESTION2FULL,
            images: [
              {
                name: values.BOARD11_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD11_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD11_QUESTION2BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 3,
            questionImage: values.BOARD11_QUESTION3ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD11_QUESTION3FULL,
            images: [
              {
                name: values.BOARD11_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD11_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD11_QUESTION5BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 1,
            questionImage: values.BOARD11_QUESTION4ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD11_QUESTION4FULL,
            images: [
              {
                name: values.BOARD11_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD11_QUESTION4BLANK,
                id: "2",
              },
              {
                name: values.BOARD11_QUESTION8BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 2,
            questionImage: values.BOARD11_QUESTION5ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD11_QUESTION5FULL,
            images: [
              {
                name: values.BOARD11_QUESTION5BLANK,
                id: "1",
              },
              {
                name: values.BOARD11_QUESTION6BLANK,
                id: "2",
              },
              {
                name: values.BOARD11_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 3,
            questionImage: values.BOARD11_QUESTION6ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD11_QUESTION6FULL,
            images: [
              {
                name: values.BOARD11_QUESTION10BLANK,
                id: "1",
              },
              {
                name: values.BOARD11_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD11_QUESTION6BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "CHOR BAZAAR",
        bazaarNameHindi: "चोर बाज़ार",
        imageName: values.MARKETTWONEW,
        pos1: 33,
        pos2: 34,
        pos3: 35,
        pos4: 30,
        pos5: 31,
        pos6: 32,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 3,
            id: 1,
            questionImage: values.BOARD11_QUESTION7ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD11_QUESTION7FULL,
            images: [
              {
                name: values.BOARD11_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD11_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD11_QUESTION14BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 2,
            questionImage: values.BOARD11_QUESTION8ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD11_QUESTION8FULL,
            images: [
              {
                name: values.BOARD11_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD11_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD11_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 3,
            questionImage: values.BOARD11_QUESTION9ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD11_QUESTION9FULL,
            images: [
              {
                name: values.BOARD11_QUESTION9BLANK,
                id: "1",
              },
              {
                name: values.BOARD11_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD11_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 1,
            questionImage: values.BOARD11_QUESTION10ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD11_QUESTION10FULL,
            images: [
              {
                name: values.BOARD11_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD11_QUESTION13BLANK,
                id: "2",
              },
              {
                name: values.BOARD11_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 2,
            questionImage: values.BOARD11_QUESTION11ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD11_QUESTION11FULL,
            images: [
              {
                name: values.BOARD11_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD11_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD11_QUESTION12BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 3,
            questionImage: values.BOARD11_QUESTION12ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD11_QUESTION12FULL,
            images: [
              {
                name: values.BOARD11_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD11_QUESTION12BLANK,
                id: "2",
              },
              {
                name: values.BOARD11_QUESTION13BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "NEHRU MARKET",
        bazaarNameHindi: "नेहरू मार्केट",
        imageName: values.MARKETTHREENEW,
        pos1: 54,
        pos2: 55,
        pos3: 43,
        pos4: 42,
        pos5: 38,
        pos6: 39,
        height: 140,
        width: 93,
        question: [
          {
            questionRound: 5,
            id: 1,
            questionImage: values.BOARD11_QUESTION13ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD11_QUESTION13FULL,
            images: [
              {
                name: values.BOARD11_QUESTION13BLANK,
                id: "1",
              },
              {
                name: values.BOARD11_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD11_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 2,
            questionImage: values.BOARD11_QUESTION14ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD11_QUESTION14FULL,
            images: [
              {
                name: values.BOARD11_QUESTION15BLANK,
                id: "1",
              },
              {
                name: values.BOARD11_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD11_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 3,
            questionImage: values.BOARD11_QUESTION15ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD11_QUESTION15FULL,
            images: [
              {
                name: values.BOARD11_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD11_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD11_QUESTION15BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 1,
            questionImage: values.BOARD11_QUESTION16ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD11_QUESTION16FULL,
            images: [
              {
                name: values.BOARD11_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD11_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD11_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 2,
            questionImage: values.BOARD11_QUESTION17ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD11_QUESTION17FULL,
            images: [
              {
                name: values.BOARD11_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD11_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD11_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 3,
            questionImage: values.BOARD11_QUESTION18ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD11_QUESTION18FULL,
            images: [
              {
                name: values.BOARD11_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD11_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD11_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
    ],
    typeOfVehicle: [
      // {
      //   door: [{ position: 64, image: values.MATCHBOX_DOOR_2 }],
      // },
      {
        train: [{ position: 45, image: values.TRAIN }],
      },
      { car: [{ position: 4, image: values.OLDCAR }] },
      {
        truck: [{ position: 28, image: values.PGNRBUS }],
      },
      { bus: [{ position: 14, image: values.REDBUS }] },
      { aeroplane: [{ position: 51, image: values.AEROPLANE }] },
      { bus2: [{ position: 59, image: values.REDBUS }] },
    ],
    gameCompleteImages: [
      { front: values.FRONTONE, back: values.BACKONE },
      { front: values.FRONTWO, back: values.BACKTWO },
      { front: values.FRONTTHREE, back: values.BACKTHREE },
      { front: values.FRONTFOUR, back: values.BACKFOUR },
    ],

    collectionRoomImages: [
      values.BOARD11_QUESTION1FULL,
      values.BOARD11_QUESTION2FULL,
      values.BOARD11_QUESTION3FULL,
      values.BOARD11_QUESTION4FULL,
      values.BOARD11_QUESTION5FULL,
      values.BOARD11_QUESTION6FULL,
      values.BOARD11_QUESTION7FULL,
      values.BOARD11_QUESTION8FULL,
      values.BOARD11_QUESTION9FULL,
      values.BOARD11_QUESTION10FULL,
      values.BOARD11_QUESTION11FULL,
      values.BOARD11_QUESTION12FULL,
      values.BOARD11_QUESTION13FULL,
      values.BOARD11_QUESTION14FULL,
      values.BOARD11_QUESTION15FULL,
      values.BOARD11_QUESTION16FULL,
      values.BOARD11_QUESTION17FULL,
      values.BOARD11_QUESTION18FULL,
    ],
    collectionRoomImagesWithoutTap: [
      {
        HD: values.BOARD11_QUESTION1FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD11_QUESTION1FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD11_QUESTION2FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD11_QUESTION2FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD11_QUESTION3FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD11_QUESTION3FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD11_QUESTION4FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD11_QUESTION4FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD11_QUESTION5FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD11_QUESTION5FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD11_QUESTION6FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD11_QUESTION6FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD11_QUESTION7FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD11_QUESTION7FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD11_QUESTION8FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD11_QUESTION8FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD11_QUESTION9FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD11_QUESTION9FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD11_QUESTION10FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD11_QUESTION10FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD11_QUESTION11FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD11_QUESTION11FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD11_QUESTION12FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD11_QUESTION12FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD11_QUESTION13FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD11_QUESTION13FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD11_QUESTION14FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD11_QUESTION14FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD11_QUESTION15FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD11_QUESTION15FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD11_QUESTION16FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD11_QUESTION16FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD11_QUESTION17FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD11_QUESTION17FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD11_QUESTION18FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD11_QUESTION18FULLWITHOUT_TAPE,
      },
    ],
    artWorkImages: [
      { HD: values.FLOWERS1_HD, WEBP: values.FLOWERS1 },
      { HD: values.FLOWERS2_HD, WEBP: values.FLOWERS2 },
      { HD: values.FLOWERS3_HD, WEBP: values.FLOWERS3 },
      { HD: values.FLOWERS4_HD, WEBP: values.FLOWERS4 },
      { HD: values.FLOWERS5_HD, WEBP: values.FLOWERS5 },
      { HD: values.FLOWERS6_HD, WEBP: values.FLOWERS6 },
      { HD: values.FLOWERS7_HD, WEBP: values.FLOWERS7 },
      { HD: values.FLOWERS8_HD, WEBP: values.FLOWERS8 },
      { HD: values.FLOWERS9_HD, WEBP: values.FLOWERS9 },
      { HD: values.FLOWERS10_HD, WEBP: values.FLOWERS10 },
    ],
    artWorkViseRoomImages: [
      { HD: values.ROOM_FLOWERS1_HD, WEBP: values.ROOM_FLOWERS1 },
      { HD: values.ROOM_FLOWERS2_HD, WEBP: values.ROOM_FLOWERS2 },
      { HD: values.ROOM_FLOWERS3_HD, WEBP: values.ROOM_FLOWERS3 },
      { HD: values.ROOM_FLOWERS4_HD, WEBP: values.ROOM_FLOWERS4 },
      { HD: values.ROOM_FLOWERS5_HD, WEBP: values.ROOM_FLOWERS5 },
      { HD: values.ROOM_FLOWERS6_HD, WEBP: values.ROOM_FLOWERS6 },
      { HD: values.ROOM_FLOWERS7_HD, WEBP: values.ROOM_FLOWERS7 },
      { HD: values.ROOM_FLOWERS8_HD, WEBP: values.ROOM_FLOWERS8 },
      { HD: values.ROOM_FLOWERS9_HD, WEBP: values.ROOM_FLOWERS9 },
      { HD: values.ROOM_FLOWERS10_HD, WEBP: values.ROOM_FLOWERS10 },
    ],
  },
  //Board 12
  {
    boardName: "Advertisement",
    boardNameHi: "विज्ञापन",
    boardImage: values.BOARD12,
    typeOfMarket: [
      {
        bazaarName: "HAUZ KHAS MARKET",
        bazaarNameHindi: "हौज़ ख़ास मार्किट",
        imageName: values.MARKETONENEW,
        pos1: 21,
        pos2: 22,
        pos3: 23,
        pos4: 10,
        pos5: 11,
        pos6: 12,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 1,
            id: 1,
            questionImage: values.BOARD12_QUESTION1ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD12_QUESTION1FULL,
            images: [
              {
                name: values.BOARD12_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD12_QUESTION2BLANK,
                id: "2",
              },
              {
                name: values.BOARD12_QUESTION3BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 2,
            questionImage: values.BOARD12_QUESTION2ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD12_QUESTION2FULL,
            images: [
              {
                name: values.BOARD12_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD12_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD12_QUESTION2BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 3,
            questionImage: values.BOARD12_QUESTION3ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD12_QUESTION3FULL,
            images: [
              {
                name: values.BOARD12_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD12_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD12_QUESTION5BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 1,
            questionImage: values.BOARD12_QUESTION4ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD12_QUESTION4FULL,
            images: [
              {
                name: values.BOARD12_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD12_QUESTION4BLANK,
                id: "2",
              },
              {
                name: values.BOARD12_QUESTION8BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 2,
            questionImage: values.BOARD12_QUESTION5ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD12_QUESTION5FULL,
            images: [
              {
                name: values.BOARD12_QUESTION5BLANK,
                id: "1",
              },
              {
                name: values.BOARD12_QUESTION6BLANK,
                id: "2",
              },
              {
                name: values.BOARD12_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 3,
            questionImage: values.BOARD12_QUESTION6ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD12_QUESTION6FULL,
            images: [
              {
                name: values.BOARD12_QUESTION10BLANK,
                id: "1",
              },
              {
                name: values.BOARD12_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD12_QUESTION6BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "CHOR BAZAAR",
        bazaarNameHindi: "चोर बाज़ार",
        imageName: values.MARKETTWONEW,
        pos1: 33,
        pos2: 34,
        pos3: 35,
        pos4: 30,
        pos5: 31,
        pos6: 32,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 3,
            id: 1,
            questionImage: values.BOARD12_QUESTION7ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD12_QUESTION7FULL,
            images: [
              {
                name: values.BOARD12_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD12_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD12_QUESTION14BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 2,
            questionImage: values.BOARD12_QUESTION8ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD12_QUESTION8FULL,
            images: [
              {
                name: values.BOARD12_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD12_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD12_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 3,
            questionImage: values.BOARD12_QUESTION9ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD12_QUESTION9FULL,
            images: [
              {
                name: values.BOARD12_QUESTION9BLANK,
                id: "1",
              },
              {
                name: values.BOARD12_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD12_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 1,
            questionImage: values.BOARD12_QUESTION10ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD12_QUESTION10FULL,
            images: [
              {
                name: values.BOARD12_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD12_QUESTION13BLANK,
                id: "2",
              },
              {
                name: values.BOARD12_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 2,
            questionImage: values.BOARD12_QUESTION11ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD12_QUESTION11FULL,
            images: [
              {
                name: values.BOARD12_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD12_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD12_QUESTION12BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 3,
            questionImage: values.BOARD12_QUESTION12ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD12_QUESTION12FULL,
            images: [
              {
                name: values.BOARD12_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD12_QUESTION12BLANK,
                id: "2",
              },
              {
                name: values.BOARD12_QUESTION13BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "NEHRU MARKET",
        bazaarNameHindi: "नेहरू मार्केट",
        imageName: values.MARKETTHREENEW,
        pos1: 54,
        pos2: 55,
        pos3: 43,
        pos4: 42,
        pos5: 38,
        pos6: 39,
        height: 140,
        width: 93,
        question: [
          {
            questionRound: 5,
            id: 1,
            questionImage: values.BOARD12_QUESTION13ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD12_QUESTION13FULL,
            images: [
              {
                name: values.BOARD12_QUESTION13BLANK,
                id: "1",
              },
              {
                name: values.BOARD12_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD12_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 2,
            questionImage: values.BOARD12_QUESTION14ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD12_QUESTION14FULL,
            images: [
              {
                name: values.BOARD12_QUESTION15BLANK,
                id: "1",
              },
              {
                name: values.BOARD12_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD12_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 3,
            questionImage: values.BOARD12_QUESTION15ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD12_QUESTION15FULL,
            images: [
              {
                name: values.BOARD12_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD12_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD12_QUESTION15BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 1,
            questionImage: values.BOARD12_QUESTION16ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD12_QUESTION16FULL,
            images: [
              {
                name: values.BOARD12_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD12_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD12_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 2,
            questionImage: values.BOARD12_QUESTION17ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD12_QUESTION17FULL,
            images: [
              {
                name: values.BOARD12_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD12_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD12_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 3,
            questionImage: values.BOARD12_QUESTION18ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD12_QUESTION18FULL,
            images: [
              {
                name: values.BOARD12_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD12_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD12_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
    ],
    typeOfVehicle: [
      // {
      //   door: [{ position: 64, image: values.MATCHBOX_DOOR_2 }],
      // },
      {
        train: [{ position: 45, image: values.TRAIN }],
      },
      { car: [{ position: 4, image: values.OLDCAR }] },
      {
        truck: [{ position: 28, image: values.PGNRBUS }],
      },
      { bus: [{ position: 14, image: values.REDBUS }] },
      { aeroplane: [{ position: 51, image: values.AEROPLANE }] },
      { bus2: [{ position: 59, image: values.REDBUS }] },
    ],
    gameCompleteImages: [
      { front: values.FRONTONE, back: values.BACKONE },
      { front: values.FRONTWO, back: values.BACKTWO },
      { front: values.FRONTTHREE, back: values.BACKTHREE },
      { front: values.FRONTFOUR, back: values.BACKFOUR },
    ],

    collectionRoomImages: [
      values.BOARD12_QUESTION1FULL,
      values.BOARD12_QUESTION2FULL,
      values.BOARD12_QUESTION3FULL,
      values.BOARD12_QUESTION4FULL,
      values.BOARD12_QUESTION5FULL,
      values.BOARD12_QUESTION6FULL,
      values.BOARD12_QUESTION7FULL,
      values.BOARD12_QUESTION8FULL,
      values.BOARD12_QUESTION9FULL,
      values.BOARD12_QUESTION10FULL,
      values.BOARD12_QUESTION11FULL,
      values.BOARD12_QUESTION12FULL,
      values.BOARD12_QUESTION13FULL,
      values.BOARD12_QUESTION14FULL,
      values.BOARD12_QUESTION15FULL,
      values.BOARD12_QUESTION16FULL,
      values.BOARD12_QUESTION17FULL,
      values.BOARD12_QUESTION18FULL,
    ],
    collectionRoomImagesWithoutTap: [
      {
        HD: values.BOARD12_QUESTION1FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD12_QUESTION1FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD12_QUESTION2FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD12_QUESTION2FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD12_QUESTION3FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD12_QUESTION3FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD12_QUESTION4FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD12_QUESTION4FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD12_QUESTION5FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD12_QUESTION5FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD12_QUESTION6FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD12_QUESTION6FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD12_QUESTION7FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD12_QUESTION7FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD12_QUESTION8FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD12_QUESTION8FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD12_QUESTION9FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD12_QUESTION9FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD12_QUESTION10FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD12_QUESTION10FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD12_QUESTION11FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD12_QUESTION11FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD12_QUESTION12FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD12_QUESTION12FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD12_QUESTION13FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD12_QUESTION13FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD12_QUESTION14FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD12_QUESTION14FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD12_QUESTION15FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD12_QUESTION15FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD12_QUESTION16FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD12_QUESTION16FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD12_QUESTION17FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD12_QUESTION17FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD12_QUESTION18FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD12_QUESTION18FULLWITHOUT_TAPE,
      },
    ],
    artWorkImages: [
      { HD: values.ADS1_HD, WEBP: values.ADS1 },
      { HD: values.ADS2_HD, WEBP: values.ADS2 },
      { HD: values.ADS3_HD, WEBP: values.ADS3 },
      { HD: values.ADS4_HD, WEBP: values.ADS4 },
      { HD: values.ADS5_HD, WEBP: values.ADS5 },
      { HD: values.ADS6_HD, WEBP: values.ADS6 },
      { HD: values.ADS7_HD, WEBP: values.ADS7 },
      { HD: values.ADS8_HD, WEBP: values.ADS8 },
      { HD: values.ADS9_HD, WEBP: values.ADS9 },
      { HD: values.ADS10_HD, WEBP: values.ADS10 },
    ],
    artWorkViseRoomImages: [
      { HD: values.ROOM_ADS1_HD, WEBP: values.ROOM_ADS1 },
      { HD: values.ROOM_ADS2_HD, WEBP: values.ROOM_ADS2 },
      { HD: values.ROOM_ADS3_HD, WEBP: values.ROOM_ADS3 },
      { HD: values.ROOM_ADS4_HD, WEBP: values.ROOM_ADS4 },
      { HD: values.ROOM_ADS5_HD, WEBP: values.ROOM_ADS5 },
      { HD: values.ROOM_ADS6_HD, WEBP: values.ROOM_ADS6 },
      { HD: values.ROOM_ADS7_HD, WEBP: values.ROOM_ADS7 },
      { HD: values.ROOM_ADS8_HD, WEBP: values.ROOM_ADS8 },
      { HD: values.ROOM_ADS9_HD, WEBP: values.ROOM_ADS9 },
      { HD: values.ROOM_ADS10_HD, WEBP: values.ROOM_ADS10 },
    ],
  },
  //Board 13
  {
    boardName: "Cinema",
    boardNameHi: "सिनेमा",
    boardImage: values.BOARD13,
    typeOfMarket: [
      {
        bazaarName: "HAUZ KHAS MARKET",
        bazaarNameHindi: "हौज़ ख़ास मार्किट",
        imageName: values.MARKETONENEW,
        pos1: 21,
        pos2: 22,
        pos3: 23,
        pos4: 10,
        pos5: 11,
        pos6: 12,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 1,
            id: 1,
            questionImage: values.BOARD13_QUESTION1ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD13_QUESTION1FULL,
            images: [
              {
                name: values.BOARD13_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD13_QUESTION2BLANK,
                id: "2",
              },
              {
                name: values.BOARD13_QUESTION3BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 2,
            questionImage: values.BOARD13_QUESTION2ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD13_QUESTION2FULL,
            images: [
              {
                name: values.BOARD13_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD13_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD13_QUESTION2BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 3,
            questionImage: values.BOARD13_QUESTION3ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD13_QUESTION3FULL,
            images: [
              {
                name: values.BOARD13_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD13_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD13_QUESTION5BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 1,
            questionImage: values.BOARD13_QUESTION4ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD13_QUESTION4FULL,
            images: [
              {
                name: values.BOARD13_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD13_QUESTION4BLANK,
                id: "2",
              },
              {
                name: values.BOARD13_QUESTION8BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 2,
            questionImage: values.BOARD13_QUESTION5ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD13_QUESTION5FULL,
            images: [
              {
                name: values.BOARD13_QUESTION5BLANK,
                id: "1",
              },
              {
                name: values.BOARD13_QUESTION6BLANK,
                id: "2",
              },
              {
                name: values.BOARD13_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 3,
            questionImage: values.BOARD13_QUESTION6ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD13_QUESTION6FULL,
            images: [
              {
                name: values.BOARD13_QUESTION10BLANK,
                id: "1",
              },
              {
                name: values.BOARD13_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD13_QUESTION6BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "CHOR BAZAAR",
        bazaarNameHindi: "चोर बाज़ार",
        imageName: values.MARKETTWONEW,
        pos1: 33,
        pos2: 34,
        pos3: 35,
        pos4: 30,
        pos5: 31,
        pos6: 32,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 3,
            id: 1,
            questionImage: values.BOARD13_QUESTION7ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD13_QUESTION7FULL,
            images: [
              {
                name: values.BOARD13_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD13_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD13_QUESTION14BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 2,
            questionImage: values.BOARD13_QUESTION8ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD13_QUESTION8FULL,
            images: [
              {
                name: values.BOARD13_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD13_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD13_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 3,
            questionImage: values.BOARD13_QUESTION9ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD13_QUESTION9FULL,
            images: [
              {
                name: values.BOARD13_QUESTION9BLANK,
                id: "1",
              },
              {
                name: values.BOARD13_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD13_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 1,
            questionImage: values.BOARD13_QUESTION10ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD13_QUESTION10FULL,
            images: [
              {
                name: values.BOARD13_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD13_QUESTION13BLANK,
                id: "2",
              },
              {
                name: values.BOARD13_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 2,
            questionImage: values.BOARD13_QUESTION11ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD13_QUESTION11FULL,
            images: [
              {
                name: values.BOARD13_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD13_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD13_QUESTION12BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 3,
            questionImage: values.BOARD13_QUESTION12ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD13_QUESTION12FULL,
            images: [
              {
                name: values.BOARD13_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD13_QUESTION12BLANK,
                id: "2",
              },
              {
                name: values.BOARD13_QUESTION13BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "NEHRU MARKET",
        bazaarNameHindi: "नेहरू मार्केट",
        imageName: values.MARKETTHREENEW,
        pos1: 54,
        pos2: 55,
        pos3: 43,
        pos4: 42,
        pos5: 38,
        pos6: 39,
        height: 140,
        width: 93,
        question: [
          {
            questionRound: 5,
            id: 1,
            questionImage: values.BOARD13_QUESTION13ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD13_QUESTION13FULL,
            images: [
              {
                name: values.BOARD13_QUESTION13BLANK,
                id: "1",
              },
              {
                name: values.BOARD13_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD13_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 2,
            questionImage: values.BOARD13_QUESTION14ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD13_QUESTION14FULL,
            images: [
              {
                name: values.BOARD13_QUESTION15BLANK,
                id: "1",
              },
              {
                name: values.BOARD13_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD13_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 3,
            questionImage: values.BOARD13_QUESTION15ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD13_QUESTION15FULL,
            images: [
              {
                name: values.BOARD13_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD13_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD13_QUESTION15BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 1,
            questionImage: values.BOARD13_QUESTION16ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD13_QUESTION16FULL,
            images: [
              {
                name: values.BOARD13_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD13_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD13_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 2,
            questionImage: values.BOARD13_QUESTION17ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD13_QUESTION17FULL,
            images: [
              {
                name: values.BOARD13_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD13_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD13_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 3,
            questionImage: values.BOARD13_QUESTION18ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD13_QUESTION18FULL,
            images: [
              {
                name: values.BOARD13_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD13_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD13_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
    ],
    typeOfVehicle: [
      // {
      //   door: [{ position: 64, image: values.MATCHBOX_DOOR_2 }],
      // },
      {
        train: [{ position: 45, image: values.TRAIN }],
      },
      { car: [{ position: 4, image: values.OLDCAR }] },
      {
        truck: [{ position: 28, image: values.PGNRBUS }],
      },
      { bus: [{ position: 14, image: values.REDBUS }] },
      { aeroplane: [{ position: 51, image: values.AEROPLANE }] },
      { bus2: [{ position: 59, image: values.REDBUS }] },
    ],
    gameCompleteImages: [
      { front: values.FRONTONE, back: values.BACKONE },
      { front: values.FRONTWO, back: values.BACKTWO },
      { front: values.FRONTTHREE, back: values.BACKTHREE },
      { front: values.FRONTFOUR, back: values.BACKFOUR },
    ],

    collectionRoomImages: [
      values.BOARD13_QUESTION1FULL,
      values.BOARD13_QUESTION2FULL,
      values.BOARD13_QUESTION3FULL,
      values.BOARD13_QUESTION4FULL,
      values.BOARD13_QUESTION5FULL,
      values.BOARD13_QUESTION6FULL,
      values.BOARD13_QUESTION7FULL,
      values.BOARD13_QUESTION8FULL,
      values.BOARD13_QUESTION9FULL,
      values.BOARD13_QUESTION10FULL,
      values.BOARD13_QUESTION11FULL,
      values.BOARD13_QUESTION12FULL,
      values.BOARD13_QUESTION13FULL,
      values.BOARD13_QUESTION14FULL,
      values.BOARD13_QUESTION15FULL,
      values.BOARD13_QUESTION16FULL,
      values.BOARD13_QUESTION17FULL,
      values.BOARD13_QUESTION18FULL,
    ],
    collectionRoomImagesWithoutTap: [
      {
        HD: values.BOARD13_QUESTION1FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD13_QUESTION1FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD13_QUESTION2FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD13_QUESTION2FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD13_QUESTION3FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD13_QUESTION3FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD13_QUESTION4FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD13_QUESTION4FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD13_QUESTION5FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD13_QUESTION5FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD13_QUESTION6FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD13_QUESTION6FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD13_QUESTION7FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD13_QUESTION7FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD13_QUESTION8FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD13_QUESTION8FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD13_QUESTION9FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD13_QUESTION9FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD13_QUESTION10FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD13_QUESTION10FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD13_QUESTION11FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD13_QUESTION11FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD13_QUESTION12FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD13_QUESTION12FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD13_QUESTION13FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD13_QUESTION13FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD13_QUESTION14FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD13_QUESTION14FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD13_QUESTION15FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD13_QUESTION15FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD13_QUESTION16FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD13_QUESTION16FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD13_QUESTION17FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD13_QUESTION17FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD13_QUESTION18FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD13_QUESTION18FULLWITHOUT_TAPE,
      },
    ],
    artWorkImages: [
      { HD: values.CINEMA1_HD, WEBP: values.CINEMA1 },
      { HD: values.CINEMA2_HD, WEBP: values.CINEMA2 },
      { HD: values.CINEMA3_HD, WEBP: values.CINEMA3 },
      { HD: values.CINEMA4_HD, WEBP: values.CINEMA4 },
      { HD: values.CINEMA5_HD, WEBP: values.CINEMA5 },
      { HD: values.CINEMA6_HD, WEBP: values.CINEMA6 },
      { HD: values.CINEMA7_HD, WEBP: values.CINEMA7 },
      { HD: values.CINEMA8_HD, WEBP: values.CINEMA8 },
      { HD: values.CINEMA9_HD, WEBP: values.CINEMA9 },
      { HD: values.CINEMA10_HD, WEBP: values.CINEMA10 },
    ],
    artWorkViseRoomImages: [
      { HD: values.ROOM_CINEMA1_HD, WEBP: values.ROOM_CINEMA1 },
      { HD: values.ROOM_CINEMA2_HD, WEBP: values.ROOM_CINEMA2 },
      { HD: values.ROOM_CINEMA3_HD, WEBP: values.ROOM_CINEMA3 },
      { HD: values.ROOM_CINEMA4_HD, WEBP: values.ROOM_CINEMA4 },
      { HD: values.ROOM_CINEMA5_HD, WEBP: values.ROOM_CINEMA5 },
      { HD: values.ROOM_CINEMA6_HD, WEBP: values.ROOM_CINEMA6 },
      { HD: values.ROOM_CINEMA7_HD, WEBP: values.ROOM_CINEMA7 },
      { HD: values.ROOM_CINEMA8_HD, WEBP: values.ROOM_CINEMA8 },
      { HD: values.ROOM_CINEMA9_HD, WEBP: values.ROOM_CINEMA9 },
      { HD: values.ROOM_CINEMA10_HD, WEBP: values.ROOM_CINEMA10 },
    ],
  },
  //Board 14
  {
    boardName: "Buildings",
    boardNameHi: "इमारतें",
    boardImage: values.BOARD14,
    typeOfMarket: [
      {
        bazaarName: "HAUZ KHAS MARKET",
        bazaarNameHindi: "हौज़ ख़ास मार्किट",
        imageName: values.MARKETONENEW,
        pos1: 21,
        pos2: 22,
        pos3: 23,
        pos4: 10,
        pos5: 11,
        pos6: 12,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 1,
            id: 1,
            questionImage: values.BOARD14_QUESTION1ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD14_QUESTION1FULL,
            images: [
              {
                name: values.BOARD14_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD14_QUESTION2BLANK,
                id: "2",
              },
              {
                name: values.BOARD14_QUESTION3BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 2,
            questionImage: values.BOARD14_QUESTION2ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD14_QUESTION2FULL,
            images: [
              {
                name: values.BOARD14_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD14_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD14_QUESTION2BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 3,
            questionImage: values.BOARD14_QUESTION3ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD14_QUESTION3FULL,
            images: [
              {
                name: values.BOARD14_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD14_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD14_QUESTION5BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 1,
            questionImage: values.BOARD14_QUESTION4ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD14_QUESTION4FULL,
            images: [
              {
                name: values.BOARD14_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD14_QUESTION4BLANK,
                id: "2",
              },
              {
                name: values.BOARD14_QUESTION8BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 2,
            questionImage: values.BOARD14_QUESTION5ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD14_QUESTION5FULL,
            images: [
              {
                name: values.BOARD14_QUESTION5BLANK,
                id: "1",
              },
              {
                name: values.BOARD14_QUESTION6BLANK,
                id: "2",
              },
              {
                name: values.BOARD14_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 3,
            questionImage: values.BOARD14_QUESTION6ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD14_QUESTION6FULL,
            images: [
              {
                name: values.BOARD14_QUESTION10BLANK,
                id: "1",
              },
              {
                name: values.BOARD14_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD14_QUESTION6BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "CHOR BAZAAR",
        bazaarNameHindi: "चोर बाज़ार",
        imageName: values.MARKETTWONEW,
        pos1: 33,
        pos2: 34,
        pos3: 35,
        pos4: 30,
        pos5: 31,
        pos6: 32,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 3,
            id: 1,
            questionImage: values.BOARD14_QUESTION7ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD14_QUESTION7FULL,
            images: [
              {
                name: values.BOARD14_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD14_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD14_QUESTION14BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 2,
            questionImage: values.BOARD14_QUESTION8ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD14_QUESTION8FULL,
            images: [
              {
                name: values.BOARD14_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD14_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD14_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 3,
            questionImage: values.BOARD14_QUESTION9ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD14_QUESTION9FULL,
            images: [
              {
                name: values.BOARD14_QUESTION9BLANK,
                id: "1",
              },
              {
                name: values.BOARD14_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD14_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 1,
            questionImage: values.BOARD14_QUESTION10ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD14_QUESTION10FULL,
            images: [
              {
                name: values.BOARD14_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD14_QUESTION13BLANK,
                id: "2",
              },
              {
                name: values.BOARD14_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 2,
            questionImage: values.BOARD14_QUESTION11ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD14_QUESTION11FULL,
            images: [
              {
                name: values.BOARD14_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD14_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD14_QUESTION12BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 3,
            questionImage: values.BOARD14_QUESTION12ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD14_QUESTION12FULL,
            images: [
              {
                name: values.BOARD14_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD14_QUESTION12BLANK,
                id: "2",
              },
              {
                name: values.BOARD14_QUESTION13BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "NEHRU MARKET",
        bazaarNameHindi: "नेहरू मार्केट",
        imageName: values.MARKETTHREENEW,
        pos1: 54,
        pos2: 55,
        pos3: 43,
        pos4: 42,
        pos5: 38,
        pos6: 39,
        height: 140,
        width: 93,
        question: [
          {
            questionRound: 5,
            id: 1,
            questionImage: values.BOARD14_QUESTION13ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD14_QUESTION13FULL,
            images: [
              {
                name: values.BOARD14_QUESTION13BLANK,
                id: "1",
              },
              {
                name: values.BOARD14_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD14_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 2,
            questionImage: values.BOARD14_QUESTION14ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD14_QUESTION14FULL,
            images: [
              {
                name: values.BOARD14_QUESTION15BLANK,
                id: "1",
              },
              {
                name: values.BOARD14_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD14_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 3,
            questionImage: values.BOARD14_QUESTION15ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD14_QUESTION15FULL,
            images: [
              {
                name: values.BOARD14_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD14_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD14_QUESTION15BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 1,
            questionImage: values.BOARD14_QUESTION16ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD14_QUESTION16FULL,
            images: [
              {
                name: values.BOARD14_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD14_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD14_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 2,
            questionImage: values.BOARD14_QUESTION17ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD14_QUESTION17FULL,
            images: [
              {
                name: values.BOARD14_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD14_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD14_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 3,
            questionImage: values.BOARD14_QUESTION18ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD14_QUESTION18FULL,
            images: [
              {
                name: values.BOARD14_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD14_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD14_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
    ],
    typeOfVehicle: [
      // {
      //   door: [{ position: 64, image: values.MATCHBOX_DOOR_2 }],
      // },
      {
        train: [{ position: 45, image: values.TRAIN }],
      },
      { car: [{ position: 4, image: values.OLDCAR }] },
      {
        truck: [{ position: 28, image: values.PGNRBUS }],
      },
      { bus: [{ position: 14, image: values.REDBUS }] },
      { aeroplane: [{ position: 51, image: values.AEROPLANE }] },
      { bus2: [{ position: 59, image: values.REDBUS }] },
    ],
    gameCompleteImages: [
      { front: values.FRONTONE, back: values.BACKONE },
      { front: values.FRONTWO, back: values.BACKTWO },
      { front: values.FRONTTHREE, back: values.BACKTHREE },
      { front: values.FRONTFOUR, back: values.BACKFOUR },
    ],

    collectionRoomImages: [
      values.BOARD14_QUESTION1FULL,
      values.BOARD14_QUESTION2FULL,
      values.BOARD14_QUESTION3FULL,
      values.BOARD14_QUESTION4FULL,
      values.BOARD14_QUESTION5FULL,
      values.BOARD14_QUESTION6FULL,
      values.BOARD14_QUESTION7FULL,
      values.BOARD14_QUESTION8FULL,
      values.BOARD14_QUESTION9FULL,
      values.BOARD14_QUESTION10FULL,
      values.BOARD14_QUESTION11FULL,
      values.BOARD14_QUESTION12FULL,
      values.BOARD14_QUESTION13FULL,
      values.BOARD14_QUESTION14FULL,
      values.BOARD14_QUESTION15FULL,
      values.BOARD14_QUESTION16FULL,
      values.BOARD14_QUESTION17FULL,
      values.BOARD14_QUESTION18FULL,
    ],
    collectionRoomImagesWithoutTap: [
      {
        HD: values.BOARD14_QUESTION1FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD14_QUESTION1FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD14_QUESTION2FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD14_QUESTION2FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD14_QUESTION3FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD14_QUESTION3FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD14_QUESTION4FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD14_QUESTION4FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD14_QUESTION5FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD14_QUESTION5FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD14_QUESTION6FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD14_QUESTION6FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD14_QUESTION7FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD14_QUESTION7FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD14_QUESTION8FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD14_QUESTION8FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD14_QUESTION9FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD14_QUESTION9FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD14_QUESTION10FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD14_QUESTION10FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD14_QUESTION11FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD14_QUESTION11FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD14_QUESTION12FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD14_QUESTION12FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD14_QUESTION13FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD14_QUESTION13FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD14_QUESTION14FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD14_QUESTION14FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD14_QUESTION15FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD14_QUESTION15FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD14_QUESTION16FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD14_QUESTION16FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD14_QUESTION17FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD14_QUESTION17FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD14_QUESTION18FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD14_QUESTION18FULLWITHOUT_TAPE,
      },
    ],
    artWorkImages: [
      { HD: values.BUILDINGS1_HD, WEBP: values.BUILDINGS1 },
      { HD: values.BUILDINGS2_HD, WEBP: values.BUILDINGS2 },
      { HD: values.BUILDINGS3_HD, WEBP: values.BUILDINGS3 },
      { HD: values.BUILDINGS4_HD, WEBP: values.BUILDINGS4 },
      { HD: values.BUILDINGS5_HD, WEBP: values.BUILDINGS5 },
      { HD: values.BUILDINGS6_HD, WEBP: values.BUILDINGS6 },
      { HD: values.BUILDINGS7_HD, WEBP: values.BUILDINGS7 },
      { HD: values.BUILDINGS8_HD, WEBP: values.BUILDINGS8 },
      { HD: values.BUILDINGS9_HD, WEBP: values.BUILDINGS9 },
      { HD: values.BUILDINGS10_HD, WEBP: values.BUILDINGS10 },
    ],
    artWorkViseRoomImages: [
      { HD: values.ROOM_BUILDINGS1_HD, WEBP: values.ROOM_BUILDINGS1 },
      { HD: values.ROOM_BUILDINGS2_HD, WEBP: values.ROOM_BUILDINGS2 },
      { HD: values.ROOM_BUILDINGS3_HD, WEBP: values.ROOM_BUILDINGS3 },
      { HD: values.ROOM_BUILDINGS4_HD, WEBP: values.ROOM_BUILDINGS4 },
      { HD: values.ROOM_BUILDINGS5_HD, WEBP: values.ROOM_BUILDINGS5 },
      { HD: values.ROOM_BUILDINGS6_HD, WEBP: values.ROOM_BUILDINGS6 },
      { HD: values.ROOM_BUILDINGS7_HD, WEBP: values.ROOM_BUILDINGS7 },
      { HD: values.ROOM_BUILDINGS8_HD, WEBP: values.ROOM_BUILDINGS8 },
      { HD: values.ROOM_BUILDINGS9_HD, WEBP: values.ROOM_BUILDINGS9 },
      { HD: values.ROOM_BUILDINGS10_HD, WEBP: values.ROOM_BUILDINGS10 },
    ],
  },
  //Board 15
  {
    boardName: "Lamps",
    boardNameHi: "लैंप",
    boardImage: values.BOARD15,
    typeOfMarket: [
      {
        bazaarName: "HAUZ KHAS MARKET",
        bazaarNameHindi: "हौज़ ख़ास मार्किट",
        imageName: values.MARKETONENEW,
        pos1: 21,
        pos2: 22,
        pos3: 23,
        pos4: 10,
        pos5: 11,
        pos6: 12,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 1,
            id: 1,
            questionImage: values.BOARD15_QUESTION1ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD15_QUESTION1FULL,
            images: [
              {
                name: values.BOARD15_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD15_QUESTION2BLANK,
                id: "2",
              },
              {
                name: values.BOARD15_QUESTION3BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 2,
            questionImage: values.BOARD15_QUESTION2ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD15_QUESTION2FULL,
            images: [
              {
                name: values.BOARD15_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD15_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD15_QUESTION2BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 3,
            questionImage: values.BOARD15_QUESTION3ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD15_QUESTION3FULL,
            images: [
              {
                name: values.BOARD15_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD15_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD15_QUESTION5BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 1,
            questionImage: values.BOARD15_QUESTION4ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD15_QUESTION4FULL,
            images: [
              {
                name: values.BOARD15_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD15_QUESTION4BLANK,
                id: "2",
              },
              {
                name: values.BOARD15_QUESTION8BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 2,
            questionImage: values.BOARD15_QUESTION5ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD15_QUESTION5FULL,
            images: [
              {
                name: values.BOARD15_QUESTION5BLANK,
                id: "1",
              },
              {
                name: values.BOARD15_QUESTION6BLANK,
                id: "2",
              },
              {
                name: values.BOARD15_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 3,
            questionImage: values.BOARD15_QUESTION6ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD15_QUESTION6FULL,
            images: [
              {
                name: values.BOARD15_QUESTION10BLANK,
                id: "1",
              },
              {
                name: values.BOARD15_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD15_QUESTION6BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "CHOR BAZAAR",
        bazaarNameHindi: "चोर बाज़ार",
        imageName: values.MARKETTWONEW,
        pos1: 33,
        pos2: 34,
        pos3: 35,
        pos4: 30,
        pos5: 31,
        pos6: 32,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 3,
            id: 1,
            questionImage: values.BOARD15_QUESTION7ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD15_QUESTION7FULL,
            images: [
              {
                name: values.BOARD15_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD15_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD15_QUESTION14BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 2,
            questionImage: values.BOARD15_QUESTION8ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD15_QUESTION8FULL,
            images: [
              {
                name: values.BOARD15_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD15_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD15_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 3,
            questionImage: values.BOARD15_QUESTION9ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD15_QUESTION9FULL,
            images: [
              {
                name: values.BOARD15_QUESTION9BLANK,
                id: "1",
              },
              {
                name: values.BOARD15_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD15_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 1,
            questionImage: values.BOARD15_QUESTION10ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD15_QUESTION10FULL,
            images: [
              {
                name: values.BOARD15_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD15_QUESTION13BLANK,
                id: "2",
              },
              {
                name: values.BOARD15_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 2,
            questionImage: values.BOARD15_QUESTION11ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD15_QUESTION11FULL,
            images: [
              {
                name: values.BOARD15_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD15_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD15_QUESTION12BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 3,
            questionImage: values.BOARD15_QUESTION12ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD15_QUESTION12FULL,
            images: [
              {
                name: values.BOARD15_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD15_QUESTION12BLANK,
                id: "2",
              },
              {
                name: values.BOARD15_QUESTION13BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "NEHRU MARKET",
        bazaarNameHindi: "नेहरू मार्केट",
        imageName: values.MARKETTHREENEW,
        pos1: 54,
        pos2: 55,
        pos3: 43,
        pos4: 42,
        pos5: 38,
        pos6: 39,
        height: 140,
        width: 93,
        question: [
          {
            questionRound: 5,
            id: 1,
            questionImage: values.BOARD15_QUESTION13ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD15_QUESTION13FULL,
            images: [
              {
                name: values.BOARD15_QUESTION13BLANK,
                id: "1",
              },
              {
                name: values.BOARD15_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD15_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 2,
            questionImage: values.BOARD15_QUESTION14ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD15_QUESTION14FULL,
            images: [
              {
                name: values.BOARD15_QUESTION15BLANK,
                id: "1",
              },
              {
                name: values.BOARD15_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD15_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 3,
            questionImage: values.BOARD15_QUESTION15ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD15_QUESTION15FULL,
            images: [
              {
                name: values.BOARD15_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD15_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD15_QUESTION15BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 1,
            questionImage: values.BOARD15_QUESTION16ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD15_QUESTION16FULL,
            images: [
              {
                name: values.BOARD15_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD15_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD15_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 2,
            questionImage: values.BOARD15_QUESTION17ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD15_QUESTION17FULL,
            images: [
              {
                name: values.BOARD15_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD15_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD15_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 3,
            questionImage: values.BOARD15_QUESTION18ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD15_QUESTION18FULL,
            images: [
              {
                name: values.BOARD15_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD15_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD15_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
    ],
    typeOfVehicle: [
      // {
      //   door: [{ position: 64, image: values.MATCHBOX_DOOR_2 }],
      // },
      {
        train: [{ position: 45, image: values.TRAIN }],
      },
      { car: [{ position: 4, image: values.OLDCAR }] },
      {
        truck: [{ position: 28, image: values.PGNRBUS }],
      },
      { bus: [{ position: 14, image: values.REDBUS }] },
      { aeroplane: [{ position: 51, image: values.AEROPLANE }] },
      { bus2: [{ position: 59, image: values.REDBUS }] },
    ],
    gameCompleteImages: [
      { front: values.FRONTONE, back: values.BACKONE },
      { front: values.FRONTWO, back: values.BACKTWO },
      { front: values.FRONTTHREE, back: values.BACKTHREE },
      { front: values.FRONTFOUR, back: values.BACKFOUR },
    ],

    collectionRoomImages: [
      values.BOARD15_QUESTION1FULL,
      values.BOARD15_QUESTION2FULL,
      values.BOARD15_QUESTION3FULL,
      values.BOARD15_QUESTION4FULL,
      values.BOARD15_QUESTION5FULL,
      values.BOARD15_QUESTION6FULL,
      values.BOARD15_QUESTION7FULL,
      values.BOARD15_QUESTION8FULL,
      values.BOARD15_QUESTION9FULL,
      values.BOARD15_QUESTION10FULL,
      values.BOARD15_QUESTION11FULL,
      values.BOARD15_QUESTION12FULL,
      values.BOARD15_QUESTION13FULL,
      values.BOARD15_QUESTION14FULL,
      values.BOARD15_QUESTION15FULL,
      values.BOARD15_QUESTION16FULL,
      values.BOARD15_QUESTION17FULL,
      values.BOARD15_QUESTION18FULL,
    ],
    collectionRoomImagesWithoutTap: [
      {
        HD: values.BOARD15_QUESTION1FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD15_QUESTION1FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD15_QUESTION2FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD15_QUESTION2FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD15_QUESTION3FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD15_QUESTION3FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD15_QUESTION4FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD15_QUESTION4FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD15_QUESTION5FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD15_QUESTION5FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD15_QUESTION6FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD15_QUESTION6FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD15_QUESTION7FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD15_QUESTION7FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD15_QUESTION8FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD15_QUESTION8FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD15_QUESTION9FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD15_QUESTION9FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD15_QUESTION10FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD15_QUESTION10FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD15_QUESTION11FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD15_QUESTION11FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD15_QUESTION12FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD15_QUESTION12FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD15_QUESTION13FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD15_QUESTION13FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD15_QUESTION14FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD15_QUESTION14FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD15_QUESTION15FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD15_QUESTION15FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD15_QUESTION16FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD15_QUESTION16FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD15_QUESTION17FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD15_QUESTION17FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD15_QUESTION18FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD15_QUESTION18FULLWITHOUT_TAPE,
      },
    ],
    artWorkImages: [
      { HD: values.LAMPS1_HD, WEBP: values.LAMPS1 },
      { HD: values.LAMPS2_HD, WEBP: values.LAMPS2 },
      { HD: values.LAMPS3_HD, WEBP: values.LAMPS3 },
      { HD: values.LAMPS4_HD, WEBP: values.LAMPS4 },
      { HD: values.LAMPS5_HD, WEBP: values.LAMPS5 },
      { HD: values.LAMPS6_HD, WEBP: values.LAMPS6 },
      { HD: values.LAMPS7_HD, WEBP: values.LAMPS7 },
      { HD: values.LAMPS8_HD, WEBP: values.LAMPS8 },
      { HD: values.LAMPS9_HD, WEBP: values.LAMPS9 },
      { HD: values.LAMPS10_HD, WEBP: values.LAMPS10 },
    ],
    artWorkViseRoomImages: [
      { HD: values.ROOM_LAMPS1_HD, WEBP: values.ROOM_LAMPS1 },
      { HD: values.ROOM_LAMPS2_HD, WEBP: values.ROOM_LAMPS2 },
      { HD: values.ROOM_LAMPS3_HD, WEBP: values.ROOM_LAMPS3 },
      { HD: values.ROOM_LAMPS4_HD, WEBP: values.ROOM_LAMPS4 },
      { HD: values.ROOM_LAMPS5_HD, WEBP: values.ROOM_LAMPS5 },
      { HD: values.ROOM_LAMPS6_HD, WEBP: values.ROOM_LAMPS6 },
      { HD: values.ROOM_LAMPS7_HD, WEBP: values.ROOM_LAMPS7 },
      { HD: values.ROOM_LAMPS8_HD, WEBP: values.ROOM_LAMPS8 },
      { HD: values.ROOM_LAMPS9_HD, WEBP: values.ROOM_LAMPS9 },
      { HD: values.ROOM_LAMPS10_HD, WEBP: values.ROOM_LAMPS10 },
    ],
  },
  //Board 16
  {
    boardName: "Babies",
    boardNameHi: "शिशु",
    boardImage: values.BOARD16,
    typeOfMarket: [
      {
        bazaarName: "HAUZ KHAS MARKET",
        bazaarNameHindi: "हौज़ ख़ास मार्किट",
        imageName: values.MARKETONENEW,
        pos1: 21,
        pos2: 22,
        pos3: 23,
        pos4: 10,
        pos5: 11,
        pos6: 12,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 1,
            id: 1,
            questionImage: values.BOARD16_QUESTION1ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD16_QUESTION1FULL,
            images: [
              {
                name: values.BOARD16_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD16_QUESTION2BLANK,
                id: "2",
              },
              {
                name: values.BOARD16_QUESTION3BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 2,
            questionImage: values.BOARD16_QUESTION2ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD16_QUESTION2FULL,
            images: [
              {
                name: values.BOARD16_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD16_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD16_QUESTION2BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 3,
            questionImage: values.BOARD16_QUESTION3ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD16_QUESTION3FULL,
            images: [
              {
                name: values.BOARD16_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD16_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD16_QUESTION5BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 1,
            questionImage: values.BOARD16_QUESTION4ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD16_QUESTION4FULL,
            images: [
              {
                name: values.BOARD16_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD16_QUESTION4BLANK,
                id: "2",
              },
              {
                name: values.BOARD16_QUESTION8BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 2,
            questionImage: values.BOARD16_QUESTION5ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD16_QUESTION5FULL,
            images: [
              {
                name: values.BOARD16_QUESTION5BLANK,
                id: "1",
              },
              {
                name: values.BOARD16_QUESTION6BLANK,
                id: "2",
              },
              {
                name: values.BOARD16_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 3,
            questionImage: values.BOARD16_QUESTION6ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD16_QUESTION6FULL,
            images: [
              {
                name: values.BOARD16_QUESTION10BLANK,
                id: "1",
              },
              {
                name: values.BOARD16_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD16_QUESTION6BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "CHOR BAZAAR",
        bazaarNameHindi: "चोर बाज़ार",
        imageName: values.MARKETTWONEW,
        pos1: 33,
        pos2: 34,
        pos3: 35,
        pos4: 30,
        pos5: 31,
        pos6: 32,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 3,
            id: 1,
            questionImage: values.BOARD16_QUESTION7ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD16_QUESTION7FULL,
            images: [
              {
                name: values.BOARD16_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD16_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD16_QUESTION14BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 2,
            questionImage: values.BOARD16_QUESTION8ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD16_QUESTION8FULL,
            images: [
              {
                name: values.BOARD16_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD16_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD16_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 3,
            questionImage: values.BOARD16_QUESTION9ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD16_QUESTION9FULL,
            images: [
              {
                name: values.BOARD16_QUESTION9BLANK,
                id: "1",
              },
              {
                name: values.BOARD16_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD16_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 1,
            questionImage: values.BOARD16_QUESTION10ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD16_QUESTION10FULL,
            images: [
              {
                name: values.BOARD16_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD16_QUESTION13BLANK,
                id: "2",
              },
              {
                name: values.BOARD16_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 2,
            questionImage: values.BOARD16_QUESTION11ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD16_QUESTION11FULL,
            images: [
              {
                name: values.BOARD16_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD16_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD16_QUESTION12BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 3,
            questionImage: values.BOARD16_QUESTION12ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD16_QUESTION12FULL,
            images: [
              {
                name: values.BOARD16_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD16_QUESTION12BLANK,
                id: "2",
              },
              {
                name: values.BOARD16_QUESTION13BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "NEHRU MARKET",
        bazaarNameHindi: "नेहरू मार्केट",
        imageName: values.MARKETTHREENEW,
        pos1: 54,
        pos2: 55,
        pos3: 43,
        pos4: 42,
        pos5: 38,
        pos6: 39,
        height: 140,
        width: 93,
        question: [
          {
            questionRound: 5,
            id: 1,
            questionImage: values.BOARD16_QUESTION13ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD16_QUESTION13FULL,
            images: [
              {
                name: values.BOARD16_QUESTION13BLANK,
                id: "1",
              },
              {
                name: values.BOARD16_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD16_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 2,
            questionImage: values.BOARD16_QUESTION14ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD16_QUESTION14FULL,
            images: [
              {
                name: values.BOARD16_QUESTION15BLANK,
                id: "1",
              },
              {
                name: values.BOARD16_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD16_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 3,
            questionImage: values.BOARD16_QUESTION15ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD16_QUESTION15FULL,
            images: [
              {
                name: values.BOARD16_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD16_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD16_QUESTION15BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 1,
            questionImage: values.BOARD16_QUESTION16ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD16_QUESTION16FULL,
            images: [
              {
                name: values.BOARD16_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD16_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD16_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 2,
            questionImage: values.BOARD16_QUESTION17ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD16_QUESTION17FULL,
            images: [
              {
                name: values.BOARD16_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD16_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD16_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 3,
            questionImage: values.BOARD16_QUESTION18ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD16_QUESTION18FULL,
            images: [
              {
                name: values.BOARD16_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD16_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD16_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
    ],
    typeOfVehicle: [
      // {
      //   door: [{ position: 64, image: values.MATCHBOX_DOOR_2 }],
      // },
      {
        train: [{ position: 45, image: values.TRAIN }],
      },
      { car: [{ position: 4, image: values.OLDCAR }] },
      {
        truck: [{ position: 28, image: values.PGNRBUS }],
      },
      { bus: [{ position: 14, image: values.REDBUS }] },
      { aeroplane: [{ position: 51, image: values.AEROPLANE }] },
      { bus2: [{ position: 59, image: values.REDBUS }] },
    ],
    gameCompleteImages: [
      { front: values.FRONTONE, back: values.BACKONE },
      { front: values.FRONTWO, back: values.BACKTWO },
      { front: values.FRONTTHREE, back: values.BACKTHREE },
      { front: values.FRONTFOUR, back: values.BACKFOUR },
    ],

    collectionRoomImages: [
      values.BOARD16_QUESTION1FULL,
      values.BOARD16_QUESTION2FULL,
      values.BOARD16_QUESTION3FULL,
      values.BOARD16_QUESTION4FULL,
      values.BOARD16_QUESTION5FULL,
      values.BOARD16_QUESTION6FULL,
      values.BOARD16_QUESTION7FULL,
      values.BOARD16_QUESTION8FULL,
      values.BOARD16_QUESTION9FULL,
      values.BOARD16_QUESTION10FULL,
      values.BOARD16_QUESTION11FULL,
      values.BOARD16_QUESTION12FULL,
      values.BOARD16_QUESTION13FULL,
      values.BOARD16_QUESTION14FULL,
      values.BOARD16_QUESTION15FULL,
      values.BOARD16_QUESTION16FULL,
      values.BOARD16_QUESTION17FULL,
      values.BOARD16_QUESTION18FULL,
    ],
    collectionRoomImagesWithoutTap: [
      {
        HD: values.BOARD16_QUESTION1FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD16_QUESTION1FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD16_QUESTION2FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD16_QUESTION2FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD16_QUESTION3FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD16_QUESTION3FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD16_QUESTION4FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD16_QUESTION4FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD16_QUESTION5FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD16_QUESTION5FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD16_QUESTION6FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD16_QUESTION6FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD16_QUESTION7FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD16_QUESTION7FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD16_QUESTION8FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD16_QUESTION8FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD16_QUESTION9FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD16_QUESTION9FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD16_QUESTION10FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD16_QUESTION10FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD16_QUESTION11FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD16_QUESTION11FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD16_QUESTION12FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD16_QUESTION12FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD16_QUESTION13FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD16_QUESTION13FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD16_QUESTION14FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD16_QUESTION14FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD16_QUESTION15FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD16_QUESTION15FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD16_QUESTION16FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD16_QUESTION16FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD16_QUESTION17FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD16_QUESTION17FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD16_QUESTION18FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD16_QUESTION18FULLWITHOUT_TAPE,
      },
    ],
    artWorkImages: [
      { HD: values.BABIES1_HD, WEBP: values.BABIES1 },
      { HD: values.BABIES2_HD, WEBP: values.BABIES2 },
      { HD: values.BABIES3_HD, WEBP: values.BABIES3 },
      { HD: values.BABIES4_HD, WEBP: values.BABIES4 },
      { HD: values.BABIES5_HD, WEBP: values.BABIES5 },
      { HD: values.BABIES6_HD, WEBP: values.BABIES6 },
      { HD: values.BABIES7_HD, WEBP: values.BABIES7 },
      { HD: values.BABIES8_HD, WEBP: values.BABIES8 },
      { HD: values.BABIES9_HD, WEBP: values.BABIES9 },
      { HD: values.BABIES10_HD, WEBP: values.BABIES10 },
    ],
    artWorkViseRoomImages: [
      { HD: values.ROOM_BABIES1_HD, WEBP: values.ROOM_BABIES1 },
      { HD: values.ROOM_BABIES2_HD, WEBP: values.ROOM_BABIES2 },
      { HD: values.ROOM_BABIES3_HD, WEBP: values.ROOM_BABIES3 },
      { HD: values.ROOM_BABIES4_HD, WEBP: values.ROOM_BABIES4 },
      { HD: values.ROOM_BABIES5_HD, WEBP: values.ROOM_BABIES5 },
      { HD: values.ROOM_BABIES6_HD, WEBP: values.ROOM_BABIES6 },
      { HD: values.ROOM_BABIES7_HD, WEBP: values.ROOM_BABIES7 },
      { HD: values.ROOM_BABIES8_HD, WEBP: values.ROOM_BABIES8 },
      { HD: values.ROOM_BABIES9_HD, WEBP: values.ROOM_BABIES9 },
      { HD: values.ROOM_BABIES10_HD, WEBP: values.ROOM_BABIES10 },
    ],
  },
  //Board 17
  {
    boardName: "Machines",
    boardNameHi: "मशीनें",
    boardImage: values.BOARD17,
    typeOfMarket: [
      {
        bazaarName: "HAUZ KHAS MARKET",
        bazaarNameHindi: "हौज़ ख़ास मार्किट",
        imageName: values.MARKETONENEW,
        pos1: 21,
        pos2: 22,
        pos3: 23,
        pos4: 10,
        pos5: 11,
        pos6: 12,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 1,
            id: 1,
            questionImage: values.BOARD17_QUESTION1ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD17_QUESTION1FULL,
            images: [
              {
                name: values.BOARD17_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD17_QUESTION2BLANK,
                id: "2",
              },
              {
                name: values.BOARD17_QUESTION3BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 2,
            questionImage: values.BOARD17_QUESTION2ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD17_QUESTION2FULL,
            images: [
              {
                name: values.BOARD17_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD17_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD17_QUESTION2BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 3,
            questionImage: values.BOARD17_QUESTION3ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD17_QUESTION3FULL,
            images: [
              {
                name: values.BOARD17_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD17_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD17_QUESTION5BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 1,
            questionImage: values.BOARD17_QUESTION4ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD17_QUESTION4FULL,
            images: [
              {
                name: values.BOARD17_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD17_QUESTION4BLANK,
                id: "2",
              },
              {
                name: values.BOARD17_QUESTION8BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 2,
            questionImage: values.BOARD17_QUESTION5ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD17_QUESTION5FULL,
            images: [
              {
                name: values.BOARD17_QUESTION5BLANK,
                id: "1",
              },
              {
                name: values.BOARD17_QUESTION6BLANK,
                id: "2",
              },
              {
                name: values.BOARD17_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 3,
            questionImage: values.BOARD17_QUESTION6ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD17_QUESTION6FULL,
            images: [
              {
                name: values.BOARD17_QUESTION10BLANK,
                id: "1",
              },
              {
                name: values.BOARD17_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD17_QUESTION6BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "CHOR BAZAAR",
        bazaarNameHindi: "चोर बाज़ार",
        imageName: values.MARKETTWONEW,
        pos1: 33,
        pos2: 34,
        pos3: 35,
        pos4: 30,
        pos5: 31,
        pos6: 32,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 3,
            id: 1,
            questionImage: values.BOARD17_QUESTION7ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD17_QUESTION7FULL,
            images: [
              {
                name: values.BOARD17_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD17_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD17_QUESTION14BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 2,
            questionImage: values.BOARD17_QUESTION8ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD17_QUESTION8FULL,
            images: [
              {
                name: values.BOARD17_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD17_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD17_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 3,
            questionImage: values.BOARD17_QUESTION9ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD17_QUESTION9FULL,
            images: [
              {
                name: values.BOARD17_QUESTION9BLANK,
                id: "1",
              },
              {
                name: values.BOARD17_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD17_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 1,
            questionImage: values.BOARD17_QUESTION10ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD17_QUESTION10FULL,
            images: [
              {
                name: values.BOARD17_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD17_QUESTION13BLANK,
                id: "2",
              },
              {
                name: values.BOARD17_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 2,
            questionImage: values.BOARD17_QUESTION11ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD17_QUESTION11FULL,
            images: [
              {
                name: values.BOARD17_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD17_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD17_QUESTION12BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 3,
            questionImage: values.BOARD17_QUESTION12ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD17_QUESTION12FULL,
            images: [
              {
                name: values.BOARD17_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD17_QUESTION12BLANK,
                id: "2",
              },
              {
                name: values.BOARD17_QUESTION13BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "NEHRU MARKET",
        bazaarNameHindi: "नेहरू मार्केट",
        imageName: values.MARKETTHREENEW,
        pos1: 54,
        pos2: 55,
        pos3: 43,
        pos4: 42,
        pos5: 38,
        pos6: 39,
        height: 140,
        width: 93,
        question: [
          {
            questionRound: 5,
            id: 1,
            questionImage: values.BOARD17_QUESTION13ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD17_QUESTION13FULL,
            images: [
              {
                name: values.BOARD17_QUESTION13BLANK,
                id: "1",
              },
              {
                name: values.BOARD17_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD17_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 2,
            questionImage: values.BOARD17_QUESTION14ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD17_QUESTION14FULL,
            images: [
              {
                name: values.BOARD17_QUESTION15BLANK,
                id: "1",
              },
              {
                name: values.BOARD17_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD17_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 3,
            questionImage: values.BOARD17_QUESTION15ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD17_QUESTION15FULL,
            images: [
              {
                name: values.BOARD17_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD17_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD17_QUESTION15BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 1,
            questionImage: values.BOARD17_QUESTION16ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD17_QUESTION16FULL,
            images: [
              {
                name: values.BOARD17_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD17_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD17_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 2,
            questionImage: values.BOARD17_QUESTION17ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD17_QUESTION17FULL,
            images: [
              {
                name: values.BOARD17_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD17_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD17_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 3,
            questionImage: values.BOARD17_QUESTION18ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD17_QUESTION18FULL,
            images: [
              {
                name: values.BOARD17_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD17_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD17_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
    ],
    typeOfVehicle: [
      // {
      //   door: [{ position: 64, image: values.MATCHBOX_DOOR_2 }],
      // },
      {
        train: [{ position: 45, image: values.TRAIN }],
      },
      { car: [{ position: 4, image: values.OLDCAR }] },
      {
        truck: [{ position: 28, image: values.PGNRBUS }],
      },
      { bus: [{ position: 14, image: values.REDBUS }] },
      { aeroplane: [{ position: 51, image: values.AEROPLANE }] },
      { bus2: [{ position: 59, image: values.REDBUS }] },
    ],
    gameCompleteImages: [
      { front: values.FRONTONE, back: values.BACKONE },
      { front: values.FRONTWO, back: values.BACKTWO },
      { front: values.FRONTTHREE, back: values.BACKTHREE },
      { front: values.FRONTFOUR, back: values.BACKFOUR },
    ],

    collectionRoomImages: [
      values.BOARD17_QUESTION1FULL,
      values.BOARD17_QUESTION2FULL,
      values.BOARD17_QUESTION3FULL,
      values.BOARD17_QUESTION4FULL,
      values.BOARD17_QUESTION5FULL,
      values.BOARD17_QUESTION6FULL,
      values.BOARD17_QUESTION7FULL,
      values.BOARD17_QUESTION8FULL,
      values.BOARD17_QUESTION9FULL,
      values.BOARD17_QUESTION10FULL,
      values.BOARD17_QUESTION11FULL,
      values.BOARD17_QUESTION12FULL,
      values.BOARD17_QUESTION13FULL,
      values.BOARD17_QUESTION14FULL,
      values.BOARD17_QUESTION15FULL,
      values.BOARD17_QUESTION16FULL,
      values.BOARD17_QUESTION17FULL,
      values.BOARD17_QUESTION18FULL,
    ],
    collectionRoomImagesWithoutTap: [
      {
        HD: values.BOARD17_QUESTION1FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD17_QUESTION1FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD17_QUESTION2FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD17_QUESTION2FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD17_QUESTION3FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD17_QUESTION3FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD17_QUESTION4FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD17_QUESTION4FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD17_QUESTION5FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD17_QUESTION5FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD17_QUESTION6FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD17_QUESTION6FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD17_QUESTION7FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD17_QUESTION7FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD17_QUESTION8FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD17_QUESTION8FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD17_QUESTION9FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD17_QUESTION9FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD17_QUESTION10FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD17_QUESTION10FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD17_QUESTION11FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD17_QUESTION11FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD17_QUESTION12FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD17_QUESTION12FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD17_QUESTION13FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD17_QUESTION13FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD17_QUESTION14FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD17_QUESTION14FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD17_QUESTION15FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD17_QUESTION15FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD17_QUESTION16FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD17_QUESTION16FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD17_QUESTION17FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD17_QUESTION17FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD17_QUESTION18FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD17_QUESTION18FULLWITHOUT_TAPE,
      },
    ],
    artWorkImages: [
      { HD: values.MACHINES1_HD, WEBP: values.MACHINES1 },
      { HD: values.MACHINES2_HD, WEBP: values.MACHINES2 },
      { HD: values.MACHINES3_HD, WEBP: values.MACHINES3 },
      { HD: values.MACHINES4_HD, WEBP: values.MACHINES4 },
      { HD: values.MACHINES5_HD, WEBP: values.MACHINES5 },
      { HD: values.MACHINES6_HD, WEBP: values.MACHINES6 },
      { HD: values.MACHINES7_HD, WEBP: values.MACHINES7 },
      { HD: values.MACHINES8_HD, WEBP: values.MACHINES8 },
      { HD: values.MACHINES9_HD, WEBP: values.MACHINES9 },
      { HD: values.MACHINES10_HD, WEBP: values.MACHINES10 },
    ],
    artWorkViseRoomImages: [
      { HD: values.ROOM_MACHINES1_HD, WEBP: values.ROOM_MACHINES1 },
      { HD: values.ROOM_MACHINES2_HD, WEBP: values.ROOM_MACHINES2 },
      { HD: values.ROOM_MACHINES3_HD, WEBP: values.ROOM_MACHINES3 },
      { HD: values.ROOM_MACHINES4_HD, WEBP: values.ROOM_MACHINES4 },
      { HD: values.ROOM_MACHINES5_HD, WEBP: values.ROOM_MACHINES5 },
      { HD: values.ROOM_MACHINES6_HD, WEBP: values.ROOM_MACHINES6 },
      { HD: values.ROOM_MACHINES7_HD, WEBP: values.ROOM_MACHINES7 },
      { HD: values.ROOM_MACHINES8_HD, WEBP: values.ROOM_MACHINES8 },
      { HD: values.ROOM_MACHINES9_HD, WEBP: values.ROOM_MACHINES9 },
      { HD: values.ROOM_MACHINES10_HD, WEBP: values.ROOM_MACHINES10 },
    ],
  },
  //Board 18
  {
    boardName: "Old Labels",
    boardNameHi: "पुराने लेबल",
    boardImage: values.BOARD18,
    typeOfMarket: [
      {
        bazaarName: "HAUZ KHAS MARKET",
        bazaarNameHindi: "हौज़ ख़ास मार्किट",
        imageName: values.MARKETONENEW,
        pos1: 21,
        pos2: 22,
        pos3: 23,
        pos4: 10,
        pos5: 11,
        pos6: 12,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 1,
            id: 1,
            questionImage: values.BOARD18_QUESTION1ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD18_QUESTION1FULL,
            images: [
              {
                name: values.BOARD18_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD18_QUESTION2BLANK,
                id: "2",
              },
              {
                name: values.BOARD18_QUESTION3BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 2,
            questionImage: values.BOARD18_QUESTION2ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD18_QUESTION2FULL,
            images: [
              {
                name: values.BOARD18_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD18_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD18_QUESTION2BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 3,
            questionImage: values.BOARD18_QUESTION3ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD18_QUESTION3FULL,
            images: [
              {
                name: values.BOARD18_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD18_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD18_QUESTION5BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 1,
            questionImage: values.BOARD18_QUESTION4ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD18_QUESTION4FULL,
            images: [
              {
                name: values.BOARD18_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD18_QUESTION4BLANK,
                id: "2",
              },
              {
                name: values.BOARD18_QUESTION8BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 2,
            questionImage: values.BOARD18_QUESTION5ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD18_QUESTION5FULL,
            images: [
              {
                name: values.BOARD18_QUESTION5BLANK,
                id: "1",
              },
              {
                name: values.BOARD18_QUESTION6BLANK,
                id: "2",
              },
              {
                name: values.BOARD18_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 3,
            questionImage: values.BOARD18_QUESTION6ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD18_QUESTION6FULL,
            images: [
              {
                name: values.BOARD18_QUESTION10BLANK,
                id: "1",
              },
              {
                name: values.BOARD18_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD18_QUESTION6BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "CHOR BAZAAR",
        bazaarNameHindi: "चोर बाज़ार",
        imageName: values.MARKETTWONEW,
        pos1: 33,
        pos2: 34,
        pos3: 35,
        pos4: 30,
        pos5: 31,
        pos6: 32,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 3,
            id: 1,
            questionImage: values.BOARD18_QUESTION7ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD18_QUESTION7FULL,
            images: [
              {
                name: values.BOARD18_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD18_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD18_QUESTION14BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 2,
            questionImage: values.BOARD18_QUESTION8ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD18_QUESTION8FULL,
            images: [
              {
                name: values.BOARD18_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD18_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD18_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 3,
            questionImage: values.BOARD18_QUESTION9ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD18_QUESTION9FULL,
            images: [
              {
                name: values.BOARD18_QUESTION9BLANK,
                id: "1",
              },
              {
                name: values.BOARD18_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD18_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 1,
            questionImage: values.BOARD18_QUESTION10ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD18_QUESTION10FULL,
            images: [
              {
                name: values.BOARD18_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD18_QUESTION13BLANK,
                id: "2",
              },
              {
                name: values.BOARD18_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 2,
            questionImage: values.BOARD18_QUESTION11ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD18_QUESTION11FULL,
            images: [
              {
                name: values.BOARD18_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD18_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD18_QUESTION12BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 3,
            questionImage: values.BOARD18_QUESTION12ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD18_QUESTION12FULL,
            images: [
              {
                name: values.BOARD18_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD18_QUESTION12BLANK,
                id: "2",
              },
              {
                name: values.BOARD18_QUESTION13BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "NEHRU MARKET",
        bazaarNameHindi: "नेहरू मार्केट",
        imageName: values.MARKETTHREENEW,
        pos1: 54,
        pos2: 55,
        pos3: 43,
        pos4: 42,
        pos5: 38,
        pos6: 39,
        height: 140,
        width: 93,
        question: [
          {
            questionRound: 5,
            id: 1,
            questionImage: values.BOARD18_QUESTION13ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD18_QUESTION13FULL,
            images: [
              {
                name: values.BOARD18_QUESTION13BLANK,
                id: "1",
              },
              {
                name: values.BOARD18_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD18_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 2,
            questionImage: values.BOARD18_QUESTION14ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD18_QUESTION14FULL,
            images: [
              {
                name: values.BOARD18_QUESTION15BLANK,
                id: "1",
              },
              {
                name: values.BOARD18_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD18_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 3,
            questionImage: values.BOARD18_QUESTION15ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD18_QUESTION15FULL,
            images: [
              {
                name: values.BOARD18_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD18_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD18_QUESTION15BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 1,
            questionImage: values.BOARD18_QUESTION16ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD18_QUESTION16FULL,
            images: [
              {
                name: values.BOARD18_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD18_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD18_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 2,
            questionImage: values.BOARD18_QUESTION17ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD18_QUESTION17FULL,
            images: [
              {
                name: values.BOARD18_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD18_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD18_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 3,
            questionImage: values.BOARD18_QUESTION18ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD18_QUESTION18FULL,
            images: [
              {
                name: values.BOARD18_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD18_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD18_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
    ],
    typeOfVehicle: [
      // {
      //   door: [{ position: 64, image: values.MATCHBOX_DOOR_2 }],
      // },
      {
        train: [{ position: 45, image: values.TRAIN }],
      },
      { car: [{ position: 4, image: values.OLDCAR }] },
      {
        truck: [{ position: 28, image: values.PGNRBUS }],
      },
      { bus: [{ position: 14, image: values.REDBUS }] },
      { aeroplane: [{ position: 51, image: values.AEROPLANE }] },
      { bus2: [{ position: 59, image: values.REDBUS }] },
    ],
    gameCompleteImages: [
      { front: values.FRONTONE, back: values.BACKONE },
      { front: values.FRONTWO, back: values.BACKTWO },
      { front: values.FRONTTHREE, back: values.BACKTHREE },
      { front: values.FRONTFOUR, back: values.BACKFOUR },
    ],

    collectionRoomImages: [
      values.BOARD18_QUESTION1FULL,
      values.BOARD18_QUESTION2FULL,
      values.BOARD18_QUESTION3FULL,
      values.BOARD18_QUESTION4FULL,
      values.BOARD18_QUESTION5FULL,
      values.BOARD18_QUESTION6FULL,
      values.BOARD18_QUESTION7FULL,
      values.BOARD18_QUESTION8FULL,
      values.BOARD18_QUESTION9FULL,
      values.BOARD18_QUESTION10FULL,
      values.BOARD18_QUESTION11FULL,
      values.BOARD18_QUESTION12FULL,
      values.BOARD18_QUESTION13FULL,
      values.BOARD18_QUESTION14FULL,
      values.BOARD18_QUESTION15FULL,
      values.BOARD18_QUESTION16FULL,
      values.BOARD18_QUESTION17FULL,
      values.BOARD18_QUESTION18FULL,
    ],
    collectionRoomImagesWithoutTap: [
      {
        HD: values.BOARD18_QUESTION1FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD18_QUESTION1FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD18_QUESTION2FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD18_QUESTION2FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD18_QUESTION3FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD18_QUESTION3FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD18_QUESTION4FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD18_QUESTION4FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD18_QUESTION5FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD18_QUESTION5FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD18_QUESTION6FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD18_QUESTION6FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD18_QUESTION7FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD18_QUESTION7FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD18_QUESTION8FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD18_QUESTION8FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD18_QUESTION9FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD18_QUESTION9FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD18_QUESTION10FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD18_QUESTION10FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD18_QUESTION11FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD18_QUESTION11FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD18_QUESTION12FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD18_QUESTION12FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD18_QUESTION13FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD18_QUESTION13FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD18_QUESTION14FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD18_QUESTION14FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD18_QUESTION15FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD18_QUESTION15FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD18_QUESTION16FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD18_QUESTION16FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD18_QUESTION17FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD18_QUESTION17FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD18_QUESTION18FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD18_QUESTION18FULLWITHOUT_TAPE,
      },
    ],
    artWorkImages: [
      { HD: values.OLD_LABELS1_HD, WEBP: values.OLD_LABELS1 },
      { HD: values.OLD_LABELS2_HD, WEBP: values.OLD_LABELS2 },
      { HD: values.OLD_LABELS3_HD, WEBP: values.OLD_LABELS3 },
      { HD: values.OLD_LABELS4_HD, WEBP: values.OLD_LABELS4 },
      { HD: values.OLD_LABELS5_HD, WEBP: values.OLD_LABELS5 },
      { HD: values.OLD_LABELS6_HD, WEBP: values.OLD_LABELS6 },
      { HD: values.OLD_LABELS7_HD, WEBP: values.OLD_LABELS7 },
      { HD: values.OLD_LABELS8_HD, WEBP: values.OLD_LABELS8 },
      { HD: values.OLD_LABELS9_HD, WEBP: values.OLD_LABELS9 },
      { HD: values.OLD_LABELS10_HD, WEBP: values.OLD_LABELS10 },
    ],
    artWorkViseRoomImages: [
      { HD: values.ROOM_OLD_LABELS1_HD, WEBP: values.ROOM_OLD_LABELS1 },
      { HD: values.ROOM_OLD_LABELS2_HD, WEBP: values.ROOM_OLD_LABELS2 },
      { HD: values.ROOM_OLD_LABELS3_HD, WEBP: values.ROOM_OLD_LABELS3 },
      { HD: values.ROOM_OLD_LABELS4_HD, WEBP: values.ROOM_OLD_LABELS4 },
      { HD: values.ROOM_OLD_LABELS5_HD, WEBP: values.ROOM_OLD_LABELS5 },
      { HD: values.ROOM_OLD_LABELS6_HD, WEBP: values.ROOM_OLD_LABELS6 },
      { HD: values.ROOM_OLD_LABELS7_HD, WEBP: values.ROOM_OLD_LABELS7 },
      { HD: values.ROOM_OLD_LABELS8_HD, WEBP: values.ROOM_OLD_LABELS8 },
      { HD: values.ROOM_OLD_LABELS9_HD, WEBP: values.ROOM_OLD_LABELS9 },
      { HD: values.ROOM_OLD_LABELS10_HD, WEBP: values.ROOM_OLD_LABELS10 },
    ],
  },
  //Board 19
  {
    boardName: "Food",
    boardNameHi: "भोजन",
    boardImage: values.BOARD19,
    typeOfMarket: [
      {
        bazaarName: "HAUZ KHAS MARKET",
        bazaarNameHindi: "हौज़ ख़ास मार्किट",
        imageName: values.MARKETONENEW,
        pos1: 21,
        pos2: 22,
        pos3: 23,
        pos4: 10,
        pos5: 11,
        pos6: 12,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 1,
            id: 1,
            questionImage: values.BOARD19_QUESTION1ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD19_QUESTION1FULL,
            images: [
              {
                name: values.BOARD19_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD19_QUESTION2BLANK,
                id: "2",
              },
              {
                name: values.BOARD19_QUESTION3BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 2,
            questionImage: values.BOARD19_QUESTION2ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD19_QUESTION2FULL,
            images: [
              {
                name: values.BOARD19_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD19_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD19_QUESTION2BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 1,
            id: 3,
            questionImage: values.BOARD19_QUESTION3ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD19_QUESTION3FULL,
            images: [
              {
                name: values.BOARD19_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD19_QUESTION3BLANK,
                id: "2",
              },
              {
                name: values.BOARD19_QUESTION5BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 1,
            questionImage: values.BOARD19_QUESTION4ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD19_QUESTION4FULL,
            images: [
              {
                name: values.BOARD19_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD19_QUESTION4BLANK,
                id: "2",
              },
              {
                name: values.BOARD19_QUESTION8BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 2,
            questionImage: values.BOARD19_QUESTION5ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD19_QUESTION5FULL,
            images: [
              {
                name: values.BOARD19_QUESTION5BLANK,
                id: "1",
              },
              {
                name: values.BOARD19_QUESTION6BLANK,
                id: "2",
              },
              {
                name: values.BOARD19_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 2,
            id: 3,
            questionImage: values.BOARD19_QUESTION6ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD19_QUESTION6FULL,
            images: [
              {
                name: values.BOARD19_QUESTION10BLANK,
                id: "1",
              },
              {
                name: values.BOARD19_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD19_QUESTION6BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "CHOR BAZAAR",
        bazaarNameHindi: "चोर बाज़ार",
        imageName: values.MARKETTWONEW,
        pos1: 33,
        pos2: 34,
        pos3: 35,
        pos4: 30,
        pos5: 31,
        pos6: 32,
        height: 93,
        width: 140,
        question: [
          {
            questionRound: 3,
            id: 1,
            questionImage: values.BOARD19_QUESTION7ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD19_QUESTION7FULL,
            images: [
              {
                name: values.BOARD19_QUESTION7BLANK,
                id: "1",
              },
              {
                name: values.BOARD19_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD19_QUESTION14BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 2,
            questionImage: values.BOARD19_QUESTION8ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD19_QUESTION8FULL,
            images: [
              {
                name: values.BOARD19_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD19_QUESTION8BLANK,
                id: "2",
              },
              {
                name: values.BOARD19_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 3,
            id: 3,
            questionImage: values.BOARD19_QUESTION9ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD19_QUESTION9FULL,
            images: [
              {
                name: values.BOARD19_QUESTION9BLANK,
                id: "1",
              },
              {
                name: values.BOARD19_QUESTION11BLANK,
                id: "2",
              },
              {
                name: values.BOARD19_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 1,
            questionImage: values.BOARD19_QUESTION10ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD19_QUESTION10FULL,
            images: [
              {
                name: values.BOARD19_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD19_QUESTION13BLANK,
                id: "2",
              },
              {
                name: values.BOARD19_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 2,
            questionImage: values.BOARD19_QUESTION11ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD19_QUESTION11FULL,
            images: [
              {
                name: values.BOARD19_QUESTION11BLANK,
                id: "1",
              },
              {
                name: values.BOARD19_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD19_QUESTION12BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 4,
            id: 3,
            questionImage: values.BOARD19_QUESTION12ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD19_QUESTION12FULL,
            images: [
              {
                name: values.BOARD19_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD19_QUESTION12BLANK,
                id: "2",
              },
              {
                name: values.BOARD19_QUESTION13BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
      {
        bazaarName: "NEHRU MARKET",
        bazaarNameHindi: "नेहरू मार्केट",
        imageName: values.MARKETTHREENEW,
        pos1: 54,
        pos2: 55,
        pos3: 43,
        pos4: 42,
        pos5: 38,
        pos6: 39,
        height: 140,
        width: 93,
        question: [
          {
            questionRound: 5,
            id: 1,
            questionImage: values.BOARD19_QUESTION13ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD19_QUESTION13FULL,
            images: [
              {
                name: values.BOARD19_QUESTION13BLANK,
                id: "1",
              },
              {
                name: values.BOARD19_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD19_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 2,
            questionImage: values.BOARD19_QUESTION14ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD19_QUESTION14FULL,
            images: [
              {
                name: values.BOARD19_QUESTION15BLANK,
                id: "1",
              },
              {
                name: values.BOARD19_QUESTION14BLANK,
                id: "2",
              },
              {
                name: values.BOARD19_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 5,
            id: 3,
            questionImage: values.BOARD19_QUESTION15ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD19_QUESTION15FULL,
            images: [
              {
                name: values.BOARD19_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD19_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD19_QUESTION15BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 1,
            questionImage: values.BOARD19_QUESTION16ICON,
            solutionImageId: "1",
            solutionFullImage: values.BOARD19_QUESTION16FULL,
            images: [
              {
                name: values.BOARD19_QUESTION16BLANK,
                id: "1",
              },
              {
                name: values.BOARD19_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD19_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 2,
            questionImage: values.BOARD19_QUESTION17ICON,
            solutionImageId: "3",
            solutionFullImage: values.BOARD19_QUESTION17FULL,
            images: [
              {
                name: values.BOARD19_QUESTION1BLANK,
                id: "1",
              },
              {
                name: values.BOARD19_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD19_QUESTION17BLANK,
                id: "3",
              },
            ],
          },
          {
            questionRound: 6,
            id: 3,
            questionImage: values.BOARD19_QUESTION18ICON,
            solutionImageId: "2",
            solutionFullImage: values.BOARD19_QUESTION18FULL,
            images: [
              {
                name: values.BOARD19_QUESTION4BLANK,
                id: "1",
              },
              {
                name: values.BOARD19_QUESTION18BLANK,
                id: "2",
              },
              {
                name: values.BOARD19_QUESTION10BLANK,
                id: "3",
              },
            ],
          },
        ],
      },
    ],
    typeOfVehicle: [
      // {
      //   door: [{ position: 64, image: values.MATCHBOX_DOOR_2 }],
      // },
      {
        train: [{ position: 45, image: values.TRAIN }],
      },
      { car: [{ position: 4, image: values.OLDCAR }] },
      {
        truck: [{ position: 28, image: values.PGNRBUS }],
      },
      { bus: [{ position: 14, image: values.REDBUS }] },
      { aeroplane: [{ position: 51, image: values.AEROPLANE }] },
      { bus2: [{ position: 59, image: values.REDBUS }] },
    ],
    gameCompleteImages: [
      { front: values.FRONTONE, back: values.BACKONE },
      { front: values.FRONTWO, back: values.BACKTWO },
      { front: values.FRONTTHREE, back: values.BACKTHREE },
      { front: values.FRONTFOUR, back: values.BACKFOUR },
    ],

    collectionRoomImages: [
      values.BOARD19_QUESTION1FULL,
      values.BOARD19_QUESTION2FULL,
      values.BOARD19_QUESTION3FULL,
      values.BOARD19_QUESTION4FULL,
      values.BOARD19_QUESTION5FULL,
      values.BOARD19_QUESTION6FULL,
      values.BOARD19_QUESTION7FULL,
      values.BOARD19_QUESTION8FULL,
      values.BOARD19_QUESTION9FULL,
      values.BOARD19_QUESTION10FULL,
      values.BOARD19_QUESTION11FULL,
      values.BOARD19_QUESTION12FULL,
      values.BOARD19_QUESTION13FULL,
      values.BOARD19_QUESTION14FULL,
      values.BOARD19_QUESTION15FULL,
      values.BOARD19_QUESTION16FULL,
      values.BOARD19_QUESTION17FULL,
      values.BOARD19_QUESTION18FULL,
    ],
    collectionRoomImagesWithoutTap: [
      {
        HD: values.BOARD19_QUESTION1FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD19_QUESTION1FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD19_QUESTION2FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD19_QUESTION2FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD19_QUESTION3FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD19_QUESTION3FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD19_QUESTION4FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD19_QUESTION4FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD19_QUESTION5FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD19_QUESTION5FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD19_QUESTION6FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD19_QUESTION6FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD19_QUESTION7FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD19_QUESTION7FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD19_QUESTION8FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD19_QUESTION8FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD19_QUESTION9FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD19_QUESTION9FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD19_QUESTION10FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD19_QUESTION10FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD19_QUESTION11FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD19_QUESTION11FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD19_QUESTION12FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD19_QUESTION12FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD19_QUESTION13FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD19_QUESTION13FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD19_QUESTION14FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD19_QUESTION14FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD19_QUESTION15FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD19_QUESTION15FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD19_QUESTION16FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD19_QUESTION16FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD19_QUESTION17FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD19_QUESTION17FULLWITHOUT_TAPE,
      },
      {
        HD: values.BOARD19_QUESTION18FULLWITHOUT_TAPE_HD,
        WEBP: values.BOARD19_QUESTION18FULLWITHOUT_TAPE,
      },
    ],
    artWorkImages: [
      { HD: values.FOOD1_HD, WEBP: values.FOOD1 },
      { HD: values.FOOD2_HD, WEBP: values.FOOD2 },
      { HD: values.FOOD3_HD, WEBP: values.FOOD3 },
      { HD: values.FOOD4_HD, WEBP: values.FOOD4 },
      { HD: values.FOOD5_HD, WEBP: values.FOOD5 },
      { HD: values.FOOD6_HD, WEBP: values.FOOD6 },
      { HD: values.FOOD7_HD, WEBP: values.FOOD7 },
      { HD: values.FOOD8_HD, WEBP: values.FOOD8 },
      { HD: values.FOOD9_HD, WEBP: values.FOOD9 },
      { HD: values.FOOD10_HD, WEBP: values.FOOD10 },
    ],
    artWorkViseRoomImages: [
      { HD: values.ROOM_FOOD1_HD, WEBP: values.ROOM_FOOD1 },
      { HD: values.ROOM_FOOD2_HD, WEBP: values.ROOM_FOOD2 },
      { HD: values.ROOM_FOOD3_HD, WEBP: values.ROOM_FOOD3 },
      { HD: values.ROOM_FOOD4_HD, WEBP: values.ROOM_FOOD4 },
      { HD: values.ROOM_FOOD5_HD, WEBP: values.ROOM_FOOD5 },
      { HD: values.ROOM_FOOD6_HD, WEBP: values.ROOM_FOOD6 },
      { HD: values.ROOM_FOOD7_HD, WEBP: values.ROOM_FOOD7 },
      { HD: values.ROOM_FOOD8_HD, WEBP: values.ROOM_FOOD8 },
      { HD: values.ROOM_FOOD9_HD, WEBP: values.ROOM_FOOD9 },
      { HD: values.ROOM_FOOD10_HD, WEBP: values.ROOM_FOOD10 },
    ],
  },
];
